import { IIcons } from './types'

export const defaultIcons: IIcons = {
  '20-accordion': {
    path:
      'M1 3a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2H3a2 2 0 01-2-2V3zm13 10a1 1 0 010 2h-4a1 1 0 010-2h4zm-6 0l-1.5 2L5 13h3zm9-10v6H3V3h14zm0 8v6H3v-6h14zM8 5L6.5 7 5 5h3zm6 0a1 1 0 010 2h-4a1 1 0 010-2h4z',
    size: 20,
  },
  '20-age-7': {
    path:
      'M17 1a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14zm-3 3H7v1.937h4.64L7.97 16h2.375L14 5.343V4z',
    size: 20,
    fill: '#4D8EB6',
  },
  '20-age-16': {
    path:
      'M17 1a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14zM8.615 4H8.37L4 5.786v1.942l2.279-.88V16h2.336V4zm5.901 0h-.329c-.948.005-1.778.27-2.49.793-.71.523-1.255 1.27-1.632 2.241-.335.863-.52 1.854-.558 2.972l-.007.425v.845c0 1.443.298 2.591.895 3.444.596.853 1.389 1.28 2.377 1.28a2.81 2.81 0 0 0 1.65-.511c.488-.34.866-.82 1.135-1.437.27-.617.405-1.309.405-2.076 0-1.207-.236-2.173-.708-2.898-.472-.724-1.102-1.086-1.89-1.086-.684 0-1.253.279-1.708.837.1-.912.383-1.622.85-2.129.424-.46.984-.714 1.678-.76l.213-.008h.12V4zM12.69 9.538c.426 0 .77.215 1.033.645.262.43.393.988.393 1.672 0 .673-.126 1.224-.38 1.654-.252.43-.589.645-1.009.645-.414 0-.747-.222-1-.667-.228-.4-.353-.985-.376-1.755l-.004-.263v-.895c.111-.293.28-.538.505-.737a1.22 1.22 0 0 1 .838-.299z',
    size: 20,
    fill: '#E99C32',
  },
  '20-age-18': {
    path:
      'M17 1a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14zm-4 5a4.002 4.002 0 0 0-3.874 3H3v5h2v-3h1v3h2v-3h1.126A4.002 4.002 0 0 0 17 10a4 4 0 0 0-4-4zm0 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4z',
    size: 20,
    fill: '#D3504C',
  },
  '20-age-12': {
    path:
      'M17 1a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14zM8 4h-.267L3 5.786v1.942l2.469-.88V16H8V4zm5.484 0c-.672 0-1.274.167-1.805.5-.532.333-.945.8-1.239 1.402a4.402 4.402 0 0 0-.433 1.723l-.007.27h2.254c0-.63.107-1.117.321-1.464.215-.347.504-.52.87-.52.333 0 .588.149.765.447.178.298.266.71.266 1.235 0 .39-.094.799-.282 1.224-.16.365-.398.78-.713 1.246l-.164.238-3.127 4.073V16H17v-1.91h-3.929l1.485-2.171c.825-1.003 1.395-1.847 1.71-2.533.315-.685.472-1.362.472-2.028 0-1.073-.284-1.901-.853-2.484S14.515 4 13.485 4z',
    size: 20,
    fill: '#D0D152',
  },
  '20-age-kids': {
    path:
      'M17 1a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14zm-1 10c-2 1-4 1.5-6 1.5S6 12 4 11c2 2.667 4 4 6 4s4-1.333 6-4zM6 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm8 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z',
    size: 20,
    fill: '#73B655',
  },
  '20-ai-assistant': {
    path:
      'M17 6C17 5.44772 17.4477 5 18 5C18.5523 5 19 4.55228 19 4C19 3.44772 18.5523 3 18 3C17.4477 3 17 2.55228 17 2C17 1.44772 16.5523 1 16 1C15.4477 1 15 1.44772 15 2C15 2.55228 14.5523 3 14 3C13.4477 3 13 3.44772 13 4C13 4.55228 13.4477 5 14 5C14.5523 5 15 5.44772 15 6C15 6.55228 15.4477 7 16 7C16.5523 7 17 6.55228 17 6Z M8 4C8 3.44772 7.55228 3 7 3C6.44772 3 6 3.44772 6 4C6 6.20914 4.20914 8 2 8C1.44772 8 1 8.44771 1 9C1 9.55229 1.44772 10 2 10C4.20914 10 6 11.7909 6 14C6 14.5523 6.44772 15 7 15C7.55228 15 8 14.5523 8 14C8 11.7909 9.79086 10 12 10C12.5523 10 13 9.55229 13 9C13 8.44771 12.5523 8 12 8C9.79086 8 8 6.20914 8 4Z M15 11C15.5523 11 16 11.4477 16 12C16 13.1046 16.8954 14 18 14C18.5523 14 19 14.4477 19 15C19 15.5523 18.5523 16 18 16C16.8954 16 16 16.8954 16 18C16 18.5523 15.5523 19 15 19C14.4477 19 14 18.5523 14 18C14 16.8954 13.1046 16 12 16C11.4477 16 11 15.5523 11 15C11 14.4477 11.4477 14 12 14C13.1046 14 14 13.1046 14 12C14 11.4477 14.4477 11 15 11Z',
    size: 20,
  },
  '20-android': {
    path:
      'M3.613 3.21l.094.083 2.53 2.529A8.964 8.964 0 0110 5c1.342 0 2.617.294 3.762.822l2.53-2.53a1 1 0 011.498 1.32l-.083.095-2.186 2.187a8.998 8.998 0 013.46 6.521l.015.32L19 14v1a2.001 2.001 0 01-1.85 1.995L17 17H3a2.001 2.001 0 01-1.995-1.85L1 15v-1c0-2.89 1.362-5.46 3.478-7.108L2.293 4.707a1 1 0 011.32-1.497zM10 7a7 7 0 00-6.996 6.76L3 14v1h14v-.985l-.003-.234A7.002 7.002 0 0010 7zm-3 3a1 1 0 110 2 1 1 0 010-2zm6 0a1 1 0 110 2 1 1 0 010-2z',
    size: 20,
  },
  '20-articles-logotype': {
    paths: [
      {
        path:
          'M13.25 1c.966 0 1.75.806 1.75 1.8v14.4c0 .994-.784 1.8-1.75 1.8H2.75C1.784 19 1 18.194 1 17.2V5.594L5.547 1h7.703z',
        fill: '#262628',
      },
      {
        path:
          'M17.667 5C18.403 5 19 5.56 19 6.25v7.5c0 .69-.597 1.25-1.333 1.25h-5.334C11.597 15 11 14.44 11 13.75V8.863L15.054 5h2.613z',
        fill: '#8FC4FE',
      },
    ],
    size: 20,
  },
  '20-assistant-logotype': {
    paths: [
      {
        path:
          'M2 0h4a2 2 0 012 2v4a2 2 0 01-2 2H2a2 2 0 01-2-2V2a2 2 0 012-2zm10 0h4a2 2 0 012 2v4a2 2 0 01-2 2h-4a2 2 0 01-2-2V2a2 2 0 012-2zM2 10h4a2 2 0 012 2v4a2 2 0 01-2 2H2a2 2 0 01-2-2v-4a2 2 0 012-2z',
        fill: '#262628',
      },
      {
        path: 'M14 10a4 4 0 110 8 4 4 0 010-8z',
        fill: '#8FC4FE',
      },
    ],
    size: 20,
  },
  '20-dashboard-logotype': {
    paths: [
      {
        path: 'M1,11a8,8 0 1,0 16,0a8,8 0 1,0 -16,0',
        fill: '#262628',
      },
      {
        path:
          'M19,11 L9,11 L9,1 L9.27990484,1.0038418 C14.5803391,1.14951265 18.8504873,5.41966086 18.9961582,10.7200952 L19,11 Z',
        fill: '#FA8E90',
      },
    ],
    size: 20,
  },
  '20-editor-logotype': {
    paths: [
      {
        path:
          'M13.25 1c.966 0 1.75.806 1.75 1.8v14.4c0 .994-.784 1.8-1.75 1.8H2.75C1.784 19 1 18.194 1 17.2V5.594L5.547 1h7.703z',
        fill: '#262628',
      },
      {
        path: 'M19 6H7a2 2 0 00-2 2v4a2 2 0 002 2h10a2 2 0 002-2V6',
        fill: '#BC9AE4',
      },
    ],
    size: 20,
  },
  '20-repository-logotype': {
    paths: [
      {
        path:
          'M3,1 L13,1 C14.1045695,1 15,1.8954305 15,3 L15,17 C15,18.1045695 14.1045695,19 13,19 L3,19 C1.8954305,19 1,18.1045695 1,17 L1,3 C1,1.8954305 1.8954305,1 3,1 Z',
        fill: '#262628',
      },
      {
        path: 'M5,6.5a1.5,1.5 0 1,0 3,0a1.5,1.5 0 1,0 -3,0',
        fill: '#9DD79C',
      },
      {
        path:
          'M7.99074439,14 C7.44357137,14 7,13.6095915 7,13.1279982 C7,12.9982859 7.03287871,12.8702074 7.0962404,12.7530953 L10.4808399,6.49730232 C10.716088,6.06249073 11.3072773,5.87785602 11.8012982,6.08490916 C12.0066295,6.17096725 12.1720711,6.31658034 12.2698479,6.49730232 L13.5440834,8.85300912 L14.0027997,8.20711499 C14.2928008,7.79872467 14.904041,7.67457501 15.3680428,7.92981896 C15.4956201,8 15.603363,8.09482807 15.6830988,8.20711499 L18.8492726,12.6658381 C19.1392737,13.0742284 18.9982183,13.6122103 18.5342165,13.8674542 C18.3767559,13.9540721 18.194808,14 18.009123,14 L7.99074439,14 Z',
        fill: '#9DD79C',
      },
    ],
    size: 20,
  },
  '20-alert': {
    path:
      'M10 19a9 9 0 1 1 0-18 9 9 0 0 1 0 18zm0-2a7 7 0 1 0 0-14 7 7 0 0 0 0 14zm0-6a1 1 0 0 1-1-1V6a1 1 0 1 1 2 0v4a1 1 0 0 1-1 1zm0 4a1 1 0 0 1-1-1v-1a1 1 0 1 1 2 0v1a1 1 0 0 1-1 1z',
    size: 20,
  },
  '20-alert-solid': {
    path:
      'M10 19a9 9 0 1 1 0-18 9 9 0 0 1 0 18zm0-8a1 1 0 0 0 1-1V6a1 1 0 1 0-2 0v4a1 1 0 0 0 1 1zm0 4a1 1 0 0 0 1-1v-1a1 1 0 1 0-2 0v1a1 1 0 0 0 1 1z',
    size: 20,
  },
  '20-alternatives': {
    path:
      'M17.444 7C18.304 7 19 7.696 19 8.556v8.888c0 .86-.696 1.556-1.556 1.556H8.556C7.696 19 7 18.304 7 17.444V8.556C7 7.696 7.696 7 8.556 7zM17 9H9v8h8V9zm-2 1c.552 0 1 .448 1 1s-.448 1-1 1h-1v3c0 .552-.448 1-1 1s-1-.448-1-1v-3h-1c-.552 0-1-.448-1-1s.448-1 1-1h4zm-3.556-9C12.304 1 13 1.696 13 2.556V5h-2V3H3v8h2v2H2.556C1.696 13 1 12.304 1 11.444V2.556C1 1.696 1.696 1 2.556 1z',
    size: 20,
  },
  '20-arrow-down': {
    path:
      'M3.708 12.708l5.585 5.585a1 1 0 0 0 1.414 0l5.588-5.588a.997.997 0 0 0-1.41-1.41L11 15.17V2a1 1 0 0 0-2 0v13.17l-3.882-3.882a.997.997 0 0 0-1.413.002 1.004 1.004 0 0 0 .003 1.418z',
    size: 20,
  },
  '20-arrow-left': {
    path:
      'M7.292 3.708L1.707 9.293a1 1 0 0 0 0 1.414l5.588 5.588a.997.997 0 0 0 1.41-1.41L4.83 11H18a1 1 0 0 0 0-2H4.83l3.882-3.882a.997.997 0 0 0-.002-1.413 1.004 1.004 0 0 0-1.418.003z',
    size: 20,
  },
  '20-arrow-right': {
    path:
      'M12.708 16.292l5.585-5.585a1 1 0 0 0 0-1.414l-5.588-5.588a.997.997 0 0 0-1.41 1.41L15.17 9H2a1 1 0 0 0 0 2h13.17l-3.882 3.882a.997.997 0 0 0 .002 1.413c.393.39 1.026.389 1.418-.003z',
    size: 20,
  },
  '20-arrow-up': {
    path:
      'M16.292 7.292l-5.585-5.585a1 1 0 0 0-1.414 0L3.705 7.295a.997.997 0 0 0 1.41 1.41L9 4.83V18a1 1 0 0 0 2 0V4.83l3.882 3.882a.997.997 0 0 0 1.413-.002 1.004 1.004 0 0 0-.003-1.418z',
    size: 20,
  },
  '20-arrowhead-down': {
    path: 'M10 13l5-6H5z',
    size: 20,
  },
  '20-arrowhead-left': {
    path: 'M7 10l6 5V5z',
    size: 20,
  },
  '20-arrowhead-right': {
    path: 'M13 10L7 5v10z',
    size: 20,
  },
  '20-arrowhead-up': {
    path: 'M10 7l-5 6h10z',
    size: 20,
  },
  '20-article': {
    path:
      'M18 17a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2h16zm0-4a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2h16zM8 1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h5zm10 8a1 1 0 0 1 0 2h-5a1 1 0 0 1 0-2h5zM8 3H3v6h5V3zm10 2a1 1 0 0 1 0 2h-5a1 1 0 0 1 0-2h5zm0-4a1 1 0 0 1 0 2h-5a1 1 0 0 1 0-2h5z',
    size: 20,
  },
  '20-article-teaser': {
    path:
      'M17 1a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14zm0 2H3v14h14V3zm-3 10a1 1 0 0 1 0 2H6a1 1 0 0 1 0-2h8zm0-8a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h2zM8 9a1 1 0 1 1 0 2H6a1 1 0 0 1 0-2h2zm0-4a1 1 0 1 1 0 2H6a1 1 0 1 1 0-2h2z',
    size: 20,
  },
  '20-assistant': {
    path:
      'M17 1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2h-3.819L10 19l-3.182-3H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14zm0 2H3v11h4.612L10 16.251 12.387 14H17V3zm-7 2l1.253 2.746L14 9l-2.747 1.253L10 13l-1.254-2.747L6 9l2.746-1.254L10 5z',
    size: 20,
  },
  '20-assistant-suggestion': {
    path:
      'M17 1c1.103 0 2 .897 2 2v6c0 1.103-.897 2-2 2h-6v6c0 1.103-.897 2-2 2H3c-1.103 0-2-.897-2-2v-6c0-1.103.897-2 2-2h6V3c0-1.103.897-2 2-2h6zm0 12c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2h-2c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2h2zm-8-2H3v6h5.997L9 11zm8 4h-2v2h1.997L17 15zm0-12h-6v6h5.997L17 3zM5 1c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2H3c-1.103 0-2-.897-2-2V3c0-1.103.897-2 2-2h2zm0 2H3v2h1.997L5 3z',
    size: 20,
  },
  '20-bell': {
    path:
      'M2 17a1 1 0 0 1 0-2h1v-5a7.003 7.003 0 0 1 5.02-6.716 2 2 0 1 1 3.96.002A7 7 0 0 1 17 10v5h1a1 1 0 0 1 0 2h-6a2 2 0 1 1-4 0H2zm8-12a5 5 0 0 0-5 5v5h10v-5a5 5 0 0 0-5-5z',
    size: 20,
  },
  '20-blank': {
    path:
      'M3,17 L17,17 L17,3 L3,3 L3,17 Z M17,1 L3,1 C1.9,1 1,1.9 1,3 L1,17 C1,18.1 1.9,19 3,19 L17,19 C18.1,19 19,18.1 19,17 L19,3 C19,1.9 18.1,1 17,1 L17,1 Z M3,5 L17,5 L17,7 L3,7 L3,5 Z M6,9 L14,9 C14.5522847,9 15,9.44771525 15,10 C15,10.5522847 14.5522847,11 14,11 L6,11 C5.44771525,11 5,10.5522847 5,10 C5,9.44771525 5.44771525,9 6,9 Z M6,13 L9,13 C9.55228475,13 10,13.4477153 10,14 C10,14.5522847 9.55228475,15 9,15 L6,15 C5.44771525,15 5,14.5522847 5,14 C5,13.4477153 5.44771525,13 6,13 Z',
    size: 20,
  },
  '20-bold': {
    path:
      'M12 17H5v-6h7c1.654 0 3 1.346 3 3s-1.346 3-3 3m1-11c0 1.654-1.346 3-3 3H5V3h5c1.654 0 3 1.346 3 3m.71 3.321A4.962 4.962 0 0 0 15 6c0-2.757-2.243-5-5-5H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h8c2.757 0 5-2.243 5-5 0-2.154-1.377-3.978-3.29-4.679',
    size: 20,
  },
  '20-bounding-box': {
    path:
      'M17 13c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2h-2c-1.103 0-2-.897-2-2H7c0 1.103-.897 2-2 2H3c-1.103 0-2-.897-2-2v-2c0-1.103.897-2 2-2V7c-1.103 0-2-.897-2-2V3c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2h6c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v2c0 1.103-.897 2-2 2v6zM5 15H3v2h1.997L5 15zm12 0h-2v2h1.997L17 15zM5 3H3v2h1.997L5 3zm12 0h-2v2h1.997L17 3zm-2 4c-1.103 0-2-.897-2-2H7c0 1.103-.897 2-2 2v6c1.103 0 2 .897 2 2h6c0-1.103.897-2 2-2V7z',
    size: 20,
  },
  '20-calendar': {
    path:
      'M15 1c.552 0 1 .448 1 1v1h1c1.105 0 2 .895 2 2v12c0 1.105-.895 2-2 2H3c-1.105 0-2-.895-2-2V5c0-1.105.895-2 2-2h1V2c0-.552.448-1 1-1s1 .448 1 1v1h8V2c0-.552.448-1 1-1zm2 8H3v8h14V9zm0-4H3v2h14V5z',
    size: 20,
  },
  '20-calendar-add-date': {
    path:
      'M15 1c.552 0 1 .448 1 1v1h1c1.105 0 2 .895 2 2v4H3v8h6v2H3c-1.105 0-2-.895-2-2V5c0-1.105.895-2 2-2h1V2c0-.552.448-1 1-1s1 .448 1 1v1h8V2c0-.552.448-1 1-1zm0 10c.513 0 .936.386.993.883L16 12v2h2c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L18 16h-2v2c0 .552-.448 1-1 1s-1-.448-1-1v-2h-2l-.117-.007c-.497-.057-.883-.48-.883-.993s.386-.936.883-.993L12 14h2v-2l.007-.117c.057-.497.48-.883.993-.883zm2-6H3v2h14V5z',
    size: 20,
  },
  '20-calendar-delete': {
    path:
      'M15 1c.552 0 1 .448 1 1v1h1c1.105 0 2 .895 2 2v6h-2V9H3v8h8v2H3c-1.105 0-2-.895-2-2V5c0-1.105.895-2 2-2h1V2c0-.552.448-1 1-1s1 .448 1 1v1h8V2c0-.552.448-1 1-1zm-1.707 12.293c.391-.391 1.023-.391 1.414 0L16 14.586l1.293-1.293c.391-.391 1.023-.391 1.414 0s.391 1.023 0 1.414L17.414 16l1.293 1.293c.391.391.391 1.023 0 1.414-.195.195-.45.293-.707.293-.256 0-.512-.098-.707-.293L16 17.414l-1.293 1.293c-.195.195-.45.293-.707.293-.256 0-.512-.098-.707-.293-.39-.391-.39-1.023 0-1.414L14.586 16l-1.293-1.293c-.39-.391-.39-1.023 0-1.414zM17 5H3v2h14V5z',
    size: 20,
  },
  '20-calendar-edit': {
    path:
      'M15 1c.552 0 1 .448 1 1v1h1c1.105 0 2 .895 2 2v4H3v8h6v2H3c-1.105 0-2-.895-2-2V5c0-1.105.895-2 2-2h1V2c0-.552.448-1 1-1s1 .448 1 1v1h8V2c0-.552.448-1 1-1zm0 12l2 2-4.219 4H11v-2l4-4zm3.07-2l.9.9c.041.491.041.817 0 .9l-.9.9-1.797-1.8.9-.9c.011.07.074.02.03.004l-.03-.004c.344 0 .51.081.897 0zM17 5H3v2h14V5z',
    size: 20,
  },
  '20-calendar-range': {
    path:
      'M15 1c.552 0 1 .448 1 1v1h1c1.105 0 2 .895 2 2v12c0 1.105-.895 2-2 2H3c-1.105 0-2-.895-2-2V5c0-1.105.895-2 2-2h1V2c0-.552.448-1 1-1s1 .448 1 1v1h8V2c0-.552.448-1 1-1zm2 8H3v8h14V9zm-4.001 1L16 13l-3.001 3v-2H7v2l-3-3 3-3v2h5.999v-2zM17 5H3v2h14V5z',
    size: 20,
  },
  '20-camera': {
    path:
      'M11.93 2a2 2 0 0 1 1.664.89L15 5h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2l1.406-2.11A2 2 0 0 1 8.07 2h3.86zm0 2H8.07l-2 3H3v9h14V7h-3.07l-2-3zM10 7a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z',
    size: 20,
  },
  '20-cart': {
    path:
      'M4.5 16a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm10 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zM4 1a1 1 0 0 1 1 1v2h13a1 1 0 0 1 .936 1.351l-3 8A1 1 0 0 1 15 14H6a3 3 0 0 1-3-3V3H2a1 1 0 1 1 0-2zm12.557 5H5v5a1 1 0 0 0 1 1h8.307l2.25-6z',
    size: 20,
  },
  '20-chart': {
    path:
      'M3 17h14V3H3v14zM17 1H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM6 9a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0v-4a1 1 0 0 1 1-1zm4-4a1 1 0 0 1 1 1v8a1 1 0 0 1-2 0V6a1 1 0 0 1 1-1zm4 6a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1z',
    size: 20,
  },
  '20-chart-candlestick': {
    path:
      'M5,1 C5.55228475,1 6,1.44771525 6,2 L6,4 L7,4 C7.55228475,4 8,4.44771525 8,5 L8,11 C8,11.5522847 7.55228475,12 7,12 L6,12 L6,18 C6,18.5522847 5.55228475,19 5,19 C4.44771525,19 4,18.5522847 4,18 L4,12 L3,12 C2.44771525,12 2,11.5522847 2,11 L2,5 C2,4.44771525 2.44771525,4 3,4 L4,4 L4,2 C4,1.44771525 4.44771525,1 5,1 Z M15,1 C15.5522847,1 16,1.44771525 16,2 L16,8 L17,8 C17.5522847,8 18,8.44771525 18,9 L18,15 C18,15.5522847 17.5522847,16 17,16 L16,16 L16,18 C16,18.5522847 15.5522847,19 15,19 C14.4477153,19 14,18.5522847 14,18 L14,16 L13,16 C12.4477153,16 12,15.5522847 12,15 L12,9 C12,8.44771525 12.4477153,8 13,8 L14,8 L14,2 C14,1.44771525 14.4477153,1 15,1 Z M16,10 L14,10 L14,14 L16,14 L16,10 Z M6,6 L4,6 L4,10 L6,10 L6,6 Z',
    size: 20,
  },
  '20-chart-line': {
    path:
      'M18 5a1 1 0 0 1 1 1v4c0 .89-1.077 1.337-1.707.707L16 9.415l-3.293 3.292a1 1 0 0 1-1.32.083l-.094-.083L8 9.414l-5.293 5.293a1 1 0 1 1-1.414-1.414l6-6a1 1 0 0 1 1.414 0L12 10.586 14.585 8l-1.292-1.293C12.663 6.077 13.109 5 14 5h4z',
    size: 20,
  },
  '20-chart-line-2': {
    path:
      'M11.8337 7.81667L15.367 1.70833L16.8087 2.54167L12.4503 10.0833L7.02532 6.95833L3.05033 13.8333H16.8337V15.5H0.166992V0.5H1.83366V12.6167L6.41699 4.66667L11.8337 7.81667Z',
    size: 20,
  },
  '20-check': {
    path:
      'M8 15a.997.997 0 0 1-.707-.293l-4-4a.999.999 0 1 1 1.414-1.414L8 12.586l7.293-7.293a.999.999 0 1 1 1.414 1.414l-8 8A.997.997 0 0 1 8 15',
    size: 20,
  },
  '20-check-solid': {
    path:
      'M8.293 13.707l-2-2a.999.999 0 1 1 1.414-1.414l1.138 1.138 3.323-4.986a.999.999 0 1 1 1.664 1.11l-4 6a1 1 0 0 1-1.539.152zM1 10c0 4.968 4.032 9 9 9s9-4.032 9-9-4.032-9-9-9-9 4.032-9 9z',
    size: 20,
  },
  '20-check-stroke': {
    path:
      'M10,1 C14.9705627,1 19,5.02943725 19,10 C19,14.9705627 14.9705627,19 10,19 C5.02943725,19 1,14.9705627 1,10 C1,5.02943725 5.02943725,1 10,1 Z M10,3 C6.13400675,3 3,6.13400675 3,10 C3,13.8659932 6.13400675,17 10,17 C13.8659932,17 17,13.8659932 17,10 C17,6.13400675 13.8659932,3 10,3 Z M13.555,6.16832 C14.014,6.47532 14.138,7.09532 13.832,7.55532 L9.832,13.55532 C9.666,13.80432 9.396,13.96632 9.099,13.99532 C9.065,13.99832 9.033,14.00032 9,14.00032 C8.736,14.00032 8.481,13.89632 8.293,13.70732 L6.293,11.70732 C5.902,11.31632 5.902,10.68432 6.293,10.29332 C6.684,9.90232 7.316,9.90232 7.707,10.29332 L8.845,11.43132 L12.168,6.44532 C12.474,5.98532 13.094,5.86132 13.555,6.16832 Z',
    size: 20,
  },
  '20-checkbox': {
    path:
      'M17 1a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14zm0 2H3v14h14V3zm-3.445 3.168c.459.307.583.927.277 1.387l-4 6a1 1 0 0 1-1.539.152l-2-2a.999.999 0 1 1 1.414-1.414l1.138 1.138 3.323-4.986a.999.999 0 0 1 1.387-.277z',
    size: 20,
  },
  '20-chevron-down': {
    path:
      'M10.707 13.707a1 1 0 01-1.32.083l-.094-.083-6-6a1 1 0 011.32-1.497l.094.083L10 11.585l5.293-5.292a1 1 0 011.32-.083l.094.083a1 1 0 01.083 1.32l-.083.094-6 6z',
    size: 20,
  },
  '20-chevron-left': {
    path:
      'M6.293 10.707a1 1 0 01-.083-1.32l.083-.094 6-6a1 1 0 011.497 1.32l-.083.094L8.415 10l5.292 5.293a1 1 0 01.083 1.32l-.083.094a1 1 0 01-1.32.083l-.094-.083-6-6z',
    size: 20,
  },
  '20-chevron-right': {
    path:
      'M13.707 9.293a1 1 0 01.083 1.32l-.083.094-6 6a1 1 0 01-1.497-1.32l.083-.094L11.585 10 6.293 4.707a1 1 0 01-.083-1.32l.083-.094a1 1 0 011.32-.083l.094.083 6 6z',
    size: 20,
  },
  '20-chevron-up': {
    path:
      'M9.293 6.293a1 1 0 011.32-.083l.094.083 6 6a1 1 0 01-1.32 1.497l-.094-.083L10 8.415l-5.293 5.292a1 1 0 01-1.32.083l-.094-.083a1 1 0 01-.083-1.32l.083-.094 6-6z',
    size: 20,
  },
  '20-clear-formatting': {
    path:
      'M14 1a1 1 0 01.117 1.993L14 3h-3.671L7.704 17H11v2l.017-.001L11 19H2a1 1 0 01-.117-1.993L2 17h3.67L8.295 3H5a1 1 0 01-.117-1.993L5 1h9zm-.707 12.293a1 1 0 011.414 0L16 14.586l1.293-1.293a1 1 0 011.414 1.414L17.414 16l1.293 1.293a.999.999 0 11-1.414 1.414L16 17.414l-1.293 1.293a.996.996 0 01-1.414 0 1 1 0 010-1.414L14.586 16l-1.293-1.293a1 1 0 010-1.414z',
    size: 20,
  },
  '20-close': {
    path:
      'M4.293 4.293a1 1 0 0 1 1.414 0L10 8.585l4.294-4.292a1 1 0 0 1 1.414 1.414L11.414 10l4.293 4.293a1 1 0 0 1 .083 1.32l-.083.094a1 1 0 0 1-1.414 0l-4.294-4.293-4.292 4.293a1 1 0 1 1-1.414-1.414L8.585 10 4.293 5.707a1 1 0 0 1-.083-1.32z',
    size: 20,
  },
  '20-close-solid': {
    path:
      'M13.707 12.293a.999.999 0 1 1-1.414 1.414L10 11.414l-2.293 2.293a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414L8.586 10 6.293 7.707a.999.999 0 1 1 1.414-1.414L10 8.586l2.293-2.293a.999.999 0 1 1 1.414 1.414L11.414 10l2.293 2.293zM10 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18z',
    size: 20,
  },
  '20-code': {
    path:
      'M11.048 3.001l.116.013c.506.084.86.534.835 1.034l-.013.116-2 12c-.09.545-.606.913-1.15.822-.506-.084-.86-.534-.835-1.034l.013-.116 2-12c.084-.506.534-.86 1.034-.835zm4.67 2.303l.082.096 3 4c.24.32.264.748.072 1.09l-.072.11-3 4c-.331.442-.958.531-1.4.2-.408-.306-.516-.863-.269-1.295l.069-.105 2.55-3.401L14.2 6.6c-.306-.408-.253-.973.104-1.319L14.4 5.2c.408-.306.973-.253 1.319.104zM5.6 5.2c.408.306.515.863.269 1.295l-.07.105-2.55 3.401L5.8 13.4c.307.408.254.973-.103 1.319L5.6 14.8c-.408.306-.973.253-1.319-.104L4.2 14.6l-3-4c-.24-.32-.264-.748-.072-1.09L1.2 9.4l3-4c.331-.442.958-.531 1.4-.2z',
    size: 20,
  },
  '20-coffee': {
    path:
      'M17,13 C17,13.551 16.551,14 16,14 L15,14 L15,9 L16,9 C16.551,9 17,9.449 17,10 L17,13 Z M13,16 C13,16.551 12.551,17 12,17 L4,17 C3.449,17 3,16.551 3,16 L3,7 L13,7 L13,16 Z M15,7 L15,5 L1,5 L1,16 C1,17.654 2.346,19 4,19 L12,19 C13.654,19 15,17.654 15,16 L16,16 C17.654,16 19,14.654 19,13 L19,10 C19,8.346 17.654,7 16,7 L15,7 Z M4,1 C4.55228475,1 5,1.44771525 5,2 L5,3 C5,3.55228475 4.55228475,4 4,4 C3.44771525,4 3,3.55228475 3,3 L3,2 C3,1.44771525 3.44771525,1 4,1 Z M8,1 C8.55228475,1 9,1.44771525 9,2 L9,3 C9,3.55228475 8.55228475,4 8,4 C7.44771525,4 7,3.55228475 7,3 L7,2 C7,1.44771525 7.44771525,1 8,1 Z M12,1 C12.5522847,1 13,1.44771525 13,2 L13,3 C13,3.55228475 12.5522847,4 12,4 C11.4477153,4 11,3.55228475 11,3 L11,2 C11,1.44771525 11.4477153,1 12,1 Z',
    size: 20,
  },
  '20-collapse-left': {
    path:
      'M18 1c.552 0 1 .448 1 1v16c0 .552-.448 1-1 1s-1-.448-1-1V2c0-.552.448-1 1-1zM7.292 3.708c.392-.392 1.025-.393 1.418-.003.392.392.392 1.023.002 1.413L4.83 9H14c.552 0 1 .448 1 1s-.448 1-1 1H4.83l3.876 3.884c.389.39.388 1.022-.001 1.411-.39.39-1.02.39-1.41 0l-5.588-5.588c-.39-.39-.39-1.024 0-1.414z',
    size: 20,
  },
  '20-collapse-right': {
    path:
      'M2 1c.552 0 1 .448 1 1v16c0 .552-.448 1-1 1s-1-.448-1-1V2c0-.552.448-1 1-1zm9.295 2.705c.39-.39 1.02-.39 1.41 0l5.588 5.588c.39.39.39 1.024 0 1.414l-5.585 5.585c-.392.392-1.025.393-1.418.003l-.002-.002c-.39-.39-.39-1.021 0-1.41L15.17 11H6c-.552 0-1-.448-1-1s.448-1 1-1h9.17l-3.876-3.884c-.389-.39-.388-1.022.001-1.411z',
    size: 20,
  },
  '20-comments': {
    path:
      'M3 1a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h12l4 3V3a2 2 0 0 0-2-2H3zm12.667 13H3V3h14v12l-1.333-1zM14 6H6v2h8V6zm0 3H6v2h8V9z',
    size: 20,
  },
  '20-company': {
    path:
      'M9 1a2 2 0 0 1 2 2v2h6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h6zM4.999 15H3v2h1.999v-2zM17 7h-6v10h6V7zm-8 8H6.999v2H9v-2zm6-2v2h-2v-2h2zM4.999 11H3v2h1.999v-2zM9 11H6.999v2H9v-2zm6-2v2h-2V9h2zM5 7H3v2h2V7zm4 0H7v2h2V7zM5 3H3v2h2V3zm4 0H7v2h2V3z',
    size: 20,
  },
  '20-comparsion-horizontal': {
    path:
      'M5 1a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2zm12 0a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2zM5 3H3v14h2V3zm12 0h-2v14h2V3zm-7 3a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1z',
    size: 20,
  },
  '20-comparsion-vertical': {
    path:
      'M17 13a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h14zm0 2H3v2h14v-2zm-4-6a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2zm4-8a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14zm0 2H3v2h14V3z',
    size: 20,
  },
  '20-copy': {
    path:
      'M16,5 C17.654,5 19,6.346 19,8 L19,8 L19,16 C19,17.654 17.654,19 16,19 L16,19 L8,19 C6.346,19 5,17.654 5,16 L5,16 L5,8 C5,6.346 6.346,5 8,5 L8,5 Z M16,7 L8,7 C7.449,7 7,7.449 7,8 L7,8 L7,16 C7,16.551 7.449,17 8,17 L8,17 L16,17 C16.552,17 17,16.551 17,16 L17,16 L17,8 C17,7.449 16.552,7 16,7 L16,7 Z M12,1 C13.302,1 14.401,1.838 14.815,3 L14.815,3 L4,3 C3.449,3 3,3.449 3,4 L3,4 L3,14.815 C1.838,14.401 1,13.302 1,12 L1,12 L1,4 C1,2.346 2.346,1 4,1 L4,1 Z',
    size: 20,
  },
  '20-cursor-drag-and-drop': {
    path:
      'M10 1L7 4.001h2V9H4V7l-3 3 3 3v-2h5v5.001H7L10 19l3-2.999h-2V11h4.999v2L19 10l-3.001-3v2H11V4.001h2z',
    size: 20,
  },
  '20-crop': {
    path:
      'M5,1 C5.51283584,1 5.93550716,1.38604019 5.99327227,1.88337887 L6,2 L6,3.999 L15,4 C15.5128358,4 15.9355072,4.38604019 15.9932723,4.88337887 L16,5 L15.999,14 L18,14 C18.5128358,14 18.9355072,14.3860402 18.9932723,14.8833789 L19,15 C19,15.5128358 18.6139598,15.9355072 18.1166211,15.9932723 L18,16 L15.999,16 L16,18 C16,18.5522847 15.5522847,19 15,19 C14.4871642,19 14.0644928,18.6139598 14.0067277,18.1166211 L14,18 L13.999,16 L5,16 C4.48716416,16 4.06449284,15.6139598 4.00672773,15.1166211 L4,15 L4,5.999 L2,6 C1.48716416,6 1.06449284,5.61395981 1.00672773,5.11662113 L1,5 C1,4.48716416 1.38604019,4.06449284 1.88337887,4.00672773 L2,4 L4,3.999 L4,2 C4,1.44771525 4.44771525,1 5,1 Z M6,5.999 L6,14 L13.999,14 L14,6 L6,5.999 Z',
    size: 20,
  },
  '20-delete': {
    path:
      'M16 5H4v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V5zm-3.5-4h-5l-1 1H4a1 1 0 1 0 0 2h12a1 1 0 0 0 0-2h-2.5l-1-1zM6 17h8V7H6v10z',
    size: 20,
  },
  '20-desktop': {
    path:
      'M8 15H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-5v2h1a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2h1v-2zm9-12H3v10h14V3z',
    size: 20,
  },
  '20-devices': {
    path:
      'M19 2v2H5v12h4v2H2a1 1 0 0 1 0-2h1V4a2 2 0 0 1 2-2h14zm-2 4a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4zm0 2h-4v8h4V8z',
    size: 20,
  },
  '20-dobre-programy': {
    path:
      'M15 6c2.21 0 4 1.79 4 4a3.999 3.999 0 01-6 3.465V17a1 1 0 01-2 0V7a1 1 0 011.912-.411A3.964 3.964 0 0115 6zM8 2a1 1 0 011 1l-.001 6.972L9 10v3a1 1 0 01-1.912.411A3.999 3.999 0 011 10a3.999 3.999 0 016.001-3.464L7 3a1 1 0 011-1zM5 8a2 2 0 102 2l-.001.017v-.034a1.999 1.999 0 00-1.85-1.978zm10 0a2 2 0 10-.001 3.999A2 2 0 0015 8z',
    size: 20,
  },
  '20-document': {
    path:
      'M12 1l5 5v11a2 2 0 01-2 2H5a2 2 0 01-2-2V3a2 2 0 012-2h7zm-1 2H5v14h10V7h-4V3z',
    size: 20,
  },
  '20-document-add': {
    path:
      'M11 1l5 5v5h-2V7h-4V3H4v14h6v2H4a2 2 0 01-2-2V3a2 2 0 012-2h7zm4 12a1 1 0 011 1v1h1a1 1 0 010 2h-1v1a1 1 0 01-2 0v-1.001L13 17a1 1 0 010-2l1-.001V14a1 1 0 011-1z',
    size: 20,
  },
  '20-document-overview': {
    path:
      'M13 1a2 2 0 011.994 1.85L15 3v3h-2V3H7v4H3v10h5v2H3a2.001 2.001 0 01-1.995-1.85L1 17V6l5-5h7zm-.5 7a4.5 4.5 0 013.81 6.895l2.397 2.398.083.094a1 1 0 01-1.403 1.403l-.094-.083-2.398-2.396A4.5 4.5 0 1112.5 8zm0 2a2.5 2.5 0 000 5 2.5 2.5 0 000-5z',
    size: 20,
  },
  '20-download': {
    path:
      'M18 13c.552 0 1 .448 1 1v3c0 1.105-.895 2-2 2H3c-1.105 0-2-.895-2-2v-3l.007-.117c.057-.497.48-.883.993-.883.552 0 1 .448 1 1v3h14v-3l.007-.117c.053-.459.417-.823.876-.876zM10 1c.552 0 1 .448 1 1v9.17l1.884-1.876c.39-.39 1.021-.389 1.411.001.39.39.39 1.02 0 1.41l-3.588 3.588c-.39.39-1.024.39-1.414 0l-3.585-3.585c-.392-.392-.393-1.025-.003-1.418.392-.392 1.023-.392 1.413-.002L9 11.17V2c0-.552.448-1 1-1z',
    size: 20,
  },
  '20-drag-and-drop': {
    path:
      'M11 17c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2zm0-7c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2zm4-7c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zM5 3c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2zm0 7c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2zm2 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z',
    size: 20,
  },
  '20-edit': {
    path:
      'M11.235 4.67l4.094 4.095L5.094 19H1v-4.094L11.235 4.669zm0 2.895l-8.188 8.188v1.2h1.2l8.188-8.188-1.2-1.2zm3.388-6.282a1 1 0 0 1 1.414 0l2.68 2.68.083.094a1 1 0 0 1-.083 1.32l-2.36 2.359-4.093-4.096z',
    size: 20,
  },
  '20-excerpt': {
    path:
      'M2 3h16a1 1 0 0 0 0-2H2a1 1 0 1 0 0 2zm16 14a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2zM4 5a1 1 0 0 1 1 1v8a1 1 0 0 1-2 0V6a1 1 0 0 1 1-1zm14 8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2h10zm0-4a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2h10zm0-4a1 1 0 0 1 0 2H8a1 1 0 1 1 0-2h10z',
    size: 20,
  },
  '20-eye': {
    path:
      'M10 3c3.314 0 6.314 2.333 9 7-2.686 4.667-5.686 7-9 7s-6.314-2.333-9-7c2.686-4.667 5.686-7 9-7zm0 2c-2.263 0-4.49 1.582-6.663 5 2.174 3.418 4.4 5 6.663 5 2.19 0 4.346-1.482 6.453-4.675l.21-.325-.21-.325C14.346 6.482 12.19 5 10 5zm0 3a2 2 0 1 1 0 4 2 2 0 0 1 0-4z',
    size: 20,
  },
  '20-eye-crossed': {
    path:
      'M18.707 1.293c.391.391.391 1.023 0 1.414l-2.945 2.945C16.888 6.756 17.967 8.206 19 10c-2.686 4.667-5.686 7-9 7-1.466 0-2.871-.457-4.215-1.37l-3.078 3.077C2.512 18.902 2.256 19 2 19c-.256 0-.512-.098-.707-.293-.391-.391-.391-1.023 0-1.414l2.946-2.944C3.113 13.244 2.033 11.795 1 10c2.686-4.667 5.686-7 9-7 1.466 0 2.871.457 4.215 1.37l3.078-3.077c.391-.391 1.023-.391 1.414 0zm-4.356 5.771l-2.418 2.419c.044.165.067.338.067.517 0 1.105-.895 2-2 2-.179 0-.352-.023-.517-.067l-2.25 2.25C8.15 14.733 9.071 15 10 15c2.19 0 4.346-1.482 6.453-4.675l.21-.325-.21-.325c-.696-1.054-1.396-1.922-2.102-2.61zM10 5c-2.263 0-4.49 1.582-6.663 5 .764 1.203 1.536 2.178 2.313 2.937l2.418-2.419C8.024 10.353 8 10.179 8 10c0-1.105.895-2 2-2 .18 0 .353.024.518.068l2.25-2.25C11.852 5.267 10.929 5 10 5z',
    size: 20,
  },
  '20-facebook': {
    path:
      'M11 18.997V11h2.562l.442-3H11V5.548c0-.926.258-1.56 1.587-1.56h1.417V1.127c-.82-.088-1.064-.13-1.888-.127C9.672 1 7.994 2.492 7.994 5.23V8H5v3h3v7.997h3z',
    size: 20,
  },
  '20-fail': {
    path:
      'M15.5986,14.1846 L5.8156,4.4016 C6.9846,3.5256 8.4306,2.9996 9.9996,2.9996 C13.8596,2.9996 16.9996,6.1406 16.9996,9.9996 C16.9996,11.5696 16.4746,13.0156 15.5986,14.1846 M2.9996,9.9996 C2.9996,8.4306 3.5256,6.9846 4.4016,5.8156 L14.1846,15.5986 C13.0156,16.4746 11.5696,16.9996 9.9996,16.9996 C6.1406,16.9996 2.9996,13.8596 2.9996,9.9996 M9.9996,0.9996 C5.0296,0.9996 0.9996,5.0296 0.9996,9.9996 C0.9996,14.9706 5.0296,18.9996 9.9996,18.9996 C14.9706,18.9996 18.9996,14.9706 18.9996,9.9996 C18.9996,5.0296 14.9706,0.9996 9.9996,0.9996',
    size: 20,
  },
  '20-flip-horizontal': {
    path:
      'M13 17a2 2 0 002 2h2a2 2 0 002-2V3a2 2 0 00-2-2h-2a2 2 0 00-2 2v14zm2 0V3h2v14h-2zM3 17V3h2v14H3zm6 1a1 1 0 001.993.117L11 18V2a1 1 0 00-1.993-.117L9 2v16zm-8-1a2 2 0 002 2h2a2 2 0 002-2V3a2 2 0 00-2-2H3a2 2 0 00-2 2v14z',
    size: 20,
  },
  '20-flip-vertical': {
    path:
      'M17 13a2 2 0 012 2v2a2 2 0 01-2 2H3a2 2 0 01-2-2v-2a2 2 0 012-2h14zm0 2H3v2h14v-2zm1-6a1 1 0 010 2H2a1 1 0 010-2zm-1-8a2 2 0 012 2v2a2 2 0 01-2 2H3a2 2 0 01-2-2V3a2 2 0 012-2h14zm0 2H3v2h14V3z',
    size: 20,
  },
  '20-folder': {
    path:
      'M0 2C0 0.945638 0.815878 0.0818349 1.85074 0.00548577L2 0H7.10773C8.10187 0 9.04356 0.446064 9.67334 1.21529L11.953 4H16C17.1046 4 18 4.89543 18 6V14C18 15.1046 17.1046 16 16 16H2C0.89543 16 0 15.1046 0 14V2ZM2 14H16V6H2V14ZM7.10773 2H2V4H9.368L8.12582 2.48226C7.90715 2.21517 7.59372 2.04626 7.25449 2.0082L7.10773 2Z',
    size: 20,
  },
  '20-folder-add': {
    path:
      'M3 16H11V18H3C1.89543 18 1 17.1046 1 16V4C1 2.94564 1.81588 2.08183 2.85074 2.00549L3 2H8.10773C9.10187 2 10.0436 2.44606 10.6733 3.21529L12.953 6H17C18.1046 6 19 6.89543 19 8V10H17V8H3V16ZM15 10C15.5128 10 15.9355 10.386 15.9933 10.8834L16 11V13H18C18.5523 13 19 13.4477 19 14C19 14.5128 18.614 14.9355 18.1166 14.9933L18 15H16V17C16 17.5523 15.5523 18 15 18C14.4477 18 14 17.5523 14 17V15H12L11.8834 14.9933C11.386 14.9355 11 14.5128 11 14C11 13.4872 11.386 13.0645 11.8834 13.0067L12 13H14V11L14.0067 10.8834C14.0645 10.386 14.4872 10 15 10ZM8.10773 4H3V6H10.368L9.12582 4.48226C8.90715 4.21517 8.59372 4.04626 8.25449 4.0082L8.10773 4Z',
    size: 20,
  },
  '20-folder-remove': {
    path:
      'M3 16H11V18H3C1.89543 18 1 17.1046 1 16V4C1 2.94564 1.81588 2.08183 2.85074 2.00549L3 2H8.10773C9.10187 2 10.0436 2.44606 10.6733 3.21529L12.953 6H17C18.1046 6 19 6.89543 19 8V10H17V8H3V16ZM13.2931 12.293C13.654 11.9321 14.2203 11.9043 14.6128 12.2097L14.7071 12.293L16.0001 13.586L17.2931 12.293C17.6841 11.902 18.3161 11.902 18.7071 12.293C19.068 12.6539 19.0958 13.2202 18.7904 13.6127L18.7071 13.707L17.4141 15L18.7071 16.293C19.0981 16.684 19.0981 17.316 18.7071 17.707C18.5121 17.902 18.2561 18 18.0001 18C17.7868 18 17.5734 17.9319 17.3954 17.7964L17.2931 17.707L16.0001 16.414L14.7071 17.707C14.5121 17.902 14.2561 18 14.0001 18C13.7441 18 13.4881 17.902 13.2931 17.707C12.9322 17.3461 12.9044 16.7798 13.2098 16.3873L13.2931 16.293L14.5861 15L13.2931 13.707C12.9021 13.316 12.9021 12.684 13.2931 12.293ZM8.10773 4H3V6H10.368L9.12582 4.48226C8.90715 4.21517 8.59372 4.04626 8.25449 4.0082L8.10773 4Z',
    size: 20,
  },
  '20-format-code': {
    path:
      'M15,13c0.6,0,1,0.4,1,1s-0.4,1-1,1H5c-0.6,0-1-0.4-1-1s0.4-1,1-1H15z M18,9c0.6,0,1,0.4,1,1s-0.4,1-1,1H8 c-0.6,0-1-0.4-1-1s0.4-1,1-1H18z M15,5c0.6,0,1,0.4,1,1s-0.4,1-1,1H5C4.4,7,4,6.6,4,6s0.4-1,1-1H15z',
    size: 20,
  },
  '20-funnel': {
    path:
      'M12 15c.552 0 1 .448 1 1s-.448 1-1 1H8c-.552 0-1-.448-1-1s.448-1 1-1h4zm3-6c.552 0 1 .448 1 1s-.448 1-1 1H5c-.552 0-1-.448-1-1s.448-1 1-1h10zm3-6c.552 0 1 .448 1 1s-.448 1-1 1H2c-.552 0-1-.448-1-1s.448-1 1-1h16z',
    size: 20,
  },
  '20-gallery': {
    path:
      'M13.444 5C14.304 5 15 5.696 15 6.556v10.888c0 .86-.696 1.556-1.556 1.556H2.556C1.696 19 1 18.304 1 17.444V6.556C1 5.696 1.696 5 2.556 5h10.888zM13 7H3v10h10V7zm-3.575 4L12 15H4l2-2.998 1.425 2.004 2-3.006zm8.02-10C18.303 1 19 1.696 19 2.556v10.888c0 .86-.696 1.556-1.556 1.556H17V3H5v-.444C5 1.696 5.696 1 6.556 1h10.888z',
    size: 20,
  },
  '20-google': {
    path:
      'M10.133 18.999L10 19c-.127 0-.254-.003-.38-.008-.02 0-.039-.002-.058-.003a8.257 8.257 0 0 1-.184-.01l-.1-.008a6.947 6.947 0 0 1-.162-.014l-.097-.01a7.31 7.31 0 0 1-.226-.027l-.015-.003a8.835 8.835 0 0 1-1.039-.203l-.03-.009a8.102 8.102 0 0 1-.601-.18 8.714 8.714 0 0 1-1-.407l-.1-.05a6.695 6.695 0 0 1-.169-.085l-.044-.024a8.302 8.302 0 0 1-.4-.224l-.041-.025a8.821 8.821 0 0 1-.934-.648l-.099-.08a4.84 4.84 0 0 1-.216-.181 9.094 9.094 0 0 1-2.064-2.595l-.024-.046a6.302 6.302 0 0 1-.086-.169l-.048-.099a4.672 4.672 0 0 1-.11-.24 8.97 8.97 0 0 1-.72-2.678l-.01-.09a6.425 6.425 0 0 1-.014-.161l-.008-.101A8.986 8.986 0 0 1 1 10l.001.164v-.076L1 10a9.187 9.187 0 0 1 .021-.622l.009-.11c.003-.05.008-.101.013-.152l.012-.115c.068-.62.2-1.222.388-1.798l.004-.01a8.965 8.965 0 0 1 .446-1.107l.038-.077a8.917 8.917 0 0 1 1.007-1.59l.08-.098c.034-.043.069-.085.104-.126.02-.024.04-.048.062-.072l.085-.098a9.095 9.095 0 0 1 1.054-1.01l.098-.077c.3-.238.611-.454.933-.649l.041-.023c.132-.08.265-.154.4-.226l.045-.023c.056-.03.112-.058.169-.086l.099-.048a4.672 4.672 0 0 1 .24-.11 8.973 8.973 0 0 1 1.36-.478l.032-.008a8.794 8.794 0 0 1 1.037-.205l.017-.001c.074-.01.149-.02.224-.028l.099-.01.16-.014.101-.008c.061-.004.122-.008.183-.01l.06-.003C9.746 1.003 9.873 1 10 1l-.164.001h.076L10 1c2.304 0 4.607.879 6.364 2.636L14.95 5.05A6.978 6.978 0 0 0 10 3l-.24.004a7.069 7.069 0 0 0-1.056.116l.098-.017c-.082.014-.164.03-.245.047l.147-.03a6.963 6.963 0 0 0-.198.04l.05-.01c-.08.016-.16.035-.24.055l.19-.045c-.08.017-.159.036-.238.056l.048-.011a6.983 6.983 0 0 0-.764.235l.085-.03a6.963 6.963 0 0 0-.212.079l.127-.05a6.952 6.952 0 0 0-.26.104l.133-.054a6.956 6.956 0 0 0-.174.071l.04-.017a6.96 6.96 0 0 0-.198.087l.158-.07a6.95 6.95 0 0 0-.235.106l.077-.036a6.973 6.973 0 0 0-1.423.87l.1-.078c-.058.044-.115.09-.172.135L5.67 4.5a7.028 7.028 0 0 0-.202.166l.13-.108c-.06.049-.12.099-.179.15l.049-.042a7.095 7.095 0 0 0-.761.754l-.042.049.042-.049a7.04 7.04 0 0 0-.15.179l.108-.13a7.035 7.035 0 0 0-.165.202l.057-.072a7.01 7.01 0 0 0-.135.172l.078-.1a7.02 7.02 0 0 0-.427.605l-.12.195a6.946 6.946 0 0 0-.323.623l.036-.077a6.959 6.959 0 0 0-.226.537l.05-.129a6.95 6.95 0 0 0-.08.212l.03-.083a6.99 6.99 0 0 0-.338 1.25l.018-.098a7.027 7.027 0 0 0-.011 2.53l-.006-.037a7.01 7.01 0 0 0 .113.534l-.011-.048a6.983 6.983 0 0 0 .235.764l-.03-.085c.025.071.051.142.079.212l-.05-.127a6.955 6.955 0 0 0 .227.536l-.036-.077a6.972 6.972 0 0 0 .865 1.417l-.073-.094c.043.057.088.113.133.17l-.06-.076c.055.07.111.14.17.208l-.11-.133c.05.062.1.122.152.182l-.042-.049a7.095 7.095 0 0 0 .754.761l.049.042-.049-.042c.059.051.119.101.179.15l-.13-.108c.063.053.126.106.19.157l-.06-.049c.057.046.114.091.172.135l-.111-.086c.197.156.402.301.616.435l.195.12a6.946 6.946 0 0 0 .623.323l-.077-.036c.078.037.156.072.235.106l-.158-.07.198.087-.04-.017c.057.024.115.048.173.07l-.133-.053c.087.036.174.07.262.103l-.129-.05c.07.029.141.055.212.08l-.083-.03a6.98 6.98 0 0 0 .762.236l-.047-.012c.08.02.16.038.239.056l-.192-.044c.08.02.16.038.241.055l-.05-.011.199.04-.149-.03c.082.018.164.034.246.048l-.097-.018A7.028 7.028 0 0 0 10 17l-.225-.004a7.044 7.044 0 0 0 1.249-.07l-.056.007a7.014 7.014 0 0 0 .752-.146l-.029.007a6.982 6.982 0 0 0 .797-.249l-.124.045c.077-.027.153-.056.23-.086l-.106.041c.075-.028.15-.058.223-.09l-.118.049c.071-.029.142-.058.213-.089l-.095.04a6.96 6.96 0 0 0 .227-.1l-.132.06c.07-.03.138-.062.207-.094l-.075.034c.08-.037.16-.075.238-.115l-.163.08c.065-.03.13-.063.195-.096l-.032.016a6.98 6.98 0 0 0 .184-.098l-.152.082c.08-.042.16-.085.24-.13l-.088.048c.073-.04.145-.08.216-.123l-.128.075c.057-.032.114-.066.17-.1l-.042.025a7.015 7.015 0 0 0 1.046-.762l-.075.066c.138-.118.272-.243.403-.373l-.027.026A6.981 6.981 0 0 0 16.929 11H10V9h9v1a8.978 8.978 0 0 1-3.32 6.983l-.1.08c-.3.237-.612.453-.934.648l-.041.023c-.132.08-.265.154-.4.226l-.045.023c-.056.03-.112.058-.169.086l-.099.048a4.672 4.672 0 0 1-.24.11 8.973 8.973 0 0 1-1.36.478l-.032.008a8.794 8.794 0 0 1-1.037.205l-.017.001c-.074.01-.149.02-.224.028l-.099.01-.16.014-.101.008c-.061.004-.122.008-.183.01l-.06.003A8.982 8.982 0 0 1 10 19l.138-.001h-.005z',
    size: 20,
  },
  '20-header': {
    path:
      'M18 1a1 1 0 0 1 0 2h-4v15a1 1 0 0 1-2 0V3H8a1 1 0 1 1 0-2h10zM2 9a1 1 0 1 1 0-2h7a1 1 0 1 1 0 2H8v9a1 1 0 0 1-2 0V9H2z',
    size: 20,
  },
  '20-holiday': {
    path:
      'M10 17a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm-4.95-2.05a1 1 0 1 1-1.414 1.414A1 1 0 0 1 5.05 14.95Zm11.314 0a1 1 0 1 1-1.414 1.414 1 1 0 0 1 1.414-1.414ZM10 5a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm8 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM2 9a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm3.05-5.364A1 1 0 1 1 3.636 5.05 1 1 0 0 1 5.05 3.636Zm11.314 0A1 1 0 1 1 14.95 5.05a1 1 0 0 1 1.414-1.414ZM10 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zz',
    size: 20,
  },
  '20-home': {
    path:
      'M9.293 1.293c.39-.39 1.024-.39 1.414 0l7 7c.188.187.293.442.293.707v9c0 .552-.448 1-1 1H3c-.552 0-1-.448-1-1V9c0-.265.105-.52.293-.707zM10 3.415L4 9.414V17h4v-4c0-.552.448-1 1-1h2c.552 0 1 .448 1 1v4h4V9.415l-6-6z',
    size: 20,
  },
  '20-image': {
    path:
      'M8.218 10l2.5 3.758 1.782-2.505L15 15H5l3.218-5zM13.5 5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zM17 1a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14zM3 3v14h14V3H3z',
    size: 20,
  },
  '20-image-add': {
    path:
      'M15 1a1 1 0 0 1 1 1v2h2a1 1 0 0 1 0 2h-2v2a1 1 0 1 1-2-.011v.001V6h-2l-.117-.007A1 1 0 0 1 12 4h2V2l.007-.117A1 1 0 0 1 15 1zm-4 0a1 1 0 0 1 0 2H3v14h14V9l.007-.117A1 1 0 0 1 19 9v8c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2z M10.718 13.758l1.782-2.505L15 15H5l3.218-5z',
    size: 20,
  },
  '20-image-full-width': {
    path:
      'M13 17a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2zm4-12a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h14zm0 2H3v6h14V7zm-4-6a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2z',
    size: 20,
  },
  '20-image-wider': {
    path:
      'M17 5a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h14zm0 2H3v6h14V7zm-2-6a1 1 0 0 1 0 2H5a1 1 0 1 1 0-2zM5 19h10a1 1 0 0 0 0-2H5a1 1 0 0 0 0 2z',
    size: 20,
  },
  '20-info': {
    path:
      'M10 1a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm0 2a7 7 0 1 0 0 14 7 7 0 0 0 0-14zm0 6a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1zm0-4a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0V6a1 1 0 0 1 1-1z',
    size: 20,
  },
  '20-info-solid': {
    path:
      'M10 1a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm0 8a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1zm0-4a1 1 0 0 0-1 1v1a1 1 0 1 0 2 0V6a1 1 0 0 0-1-1z',
    size: 20,
  },
  '20-internet': {
    path:
      'M10 1a9 9 0 1 1 0 18 9 9 0 0 1 0-18zM3.245 8.168l-.052.195A7 7 0 0 0 10 17l.212-.002c-.21-.007-.416-.029-.623-.049a4.586 4.586 0 0 0-.614-1.97c.115.026.23.054.268.075l.004.003L9.248 14c-.693 0-1.419-.586-2.043-1.337l-.132-.163v-.75L3.92 8.469c-.03.134-.026.275-.044.412a4.44 4.44 0 0 0-.63-.713zm6.002 6.889l.001.018.008-.01-.009-.008zm3.755-11.383l.005.026c.063.27.15.534.263.79-.11-.048-.214-.105-.327-.148-.056.786-.813 1.408-1.737 1.408H9.248v1.5s-.172.75-.653.375H7.073V9.5h4.568c.48 0 .87.336.87.75v2.063h1.305s1.142.46 1.453.869c.124-.124.236-.257.345-.391.031.362.108.72.226 1.067a7 7 0 0 0-2.838-10.183z',
    size: 20,
  },
  '20-ios': {
    path:
      'M2 8a1 1 0 01.993.883L3 9v5a1 1 0 01-1.993.117L1 14V9a1 1 0 011-1zm6-3c2.53 0 4 2.129 4 5s-1.47 5-4 5c-2.53 0-4-2.129-4-5s1.47-5 4-5zm8 0c1.861 0 3 1.012 3 2.778a1 1 0 01-1.993.116L17 7.778C17 7.173 16.806 7 16 7s-1 .173-1 .778c0 .895.216 1.188.872 1.22L16 9c1.91 0 3 1.21 3 3.222C19 13.988 17.861 15 16 15s-3-1.012-3-2.778a1 1 0 012 0c0 .605.194.778 1 .778s1-.173 1-.778c0-.895-.216-1.188-.872-1.22L16 11c-1.91 0-3-1.21-3-3.222C13 6.012 14.139 5 16 5zM8 7c-1.234 0-2 1.11-2 3s.766 3 2 3 2-1.11 2-3-.766-3-2-3zM2 5a1 1 0 110 2 1 1 0 010-2z',
    size: 20,
  },
  '20-italic': {
    path:
      'M16 1H7a1 1 0 1 0 0 2h3.296L7.671 17H4a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2H9.704l2.625-14H16a1 1 0 1 0 0-2',
    size: 20,
  },
  '20-keyboard': {
    path:
      'M15 8h2V6h-2v2zm0 3h2V9h-2v2zm-3-3h2V6h-2v2zm0 3h2V9h-2v2zm-6 3h8v-2H6v2zM3 8h2V6H3v2zm0 3h2V9H3v2zm3 0h2V9H6v2zm0-3h2V6H6v2zm3 3h2V9H9v2zm0-3h2V6H9v2zm9-5H2C.9 3 .01 3.9.01 5L0 15c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM2 15h16V5H2v10z',
    size: 20,
  },
  '20-lens': {
    path:
      'M10 1a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm2 12.464-4.977 2.873A6.973 6.973 0 0 0 10 17c.695 0 1.367-.101 2.001-.29L12 13.464zm2-3.465.001 5.745a7.007 7.007 0 0 0 2.81-4.122L14 10zm-10.975.594a6.98 6.98 0 0 0 2.166 4.493L8 13.464zM9.999 7.69 8 8.844v2.311l2 1.154 2-1.154v-2.31L9.999 7.69zm-4-3.435a7.007 7.007 0 0 0-2.81 4.123L6 10zm8.81.659L12 6.535l4.975 2.872a6.98 6.98 0 0 0-2.166-4.493zM10 3c-.695 0-1.366.101-2 .29v3.245l4.977-2.872a6.965 6.965 0 0 0-2.736-.659z',
    size: 20,
  },
  '20-link': {
    path:
      'M15.808 8.274l2.06 2.06a3.89 3.89 0 0 1 0 5.494l-2.04 2.04a3.87 3.87 0 0 1-2.747 1.135 3.87 3.87 0 0 1-2.747-1.136l-2.06-2.059a.999.999 0 1 1 1.415-1.414l2.059 2.06a1.887 1.887 0 0 0 2.666 0l2.04-2.04a1.89 1.89 0 0 0 0-2.666l-2.06-2.059a1 1 0 1 1 1.414-1.415zM8.669 7.255l4.08 4.08a.999.999 0 1 1-1.415 1.413L7.255 8.67A.999.999 0 1 1 8.67 7.255zm1-5.12l2.06 2.06a.999.999 0 1 1-1.414 1.415l-2.06-2.06a1.89 1.89 0 0 0-2.666 0L3.55 5.59a1.888 1.888 0 0 0 0 2.665l2.06 2.06a.999.999 0 0 1-.707 1.707c-.237 0-1.337-.947-.849-.438l.048.05-1.966-1.965a3.89 3.89 0 0 1 0-5.493l2.04-2.04a3.89 3.89 0 0 1 5.494 0z',
    size: 20,
  },
  '20-link-external': {
    path:
      'M12 2a1 1 0 0 0 1 1h2.59l-9.125 9.125a.997.997 0 1 0 1.41 1.41L17 4.41V7a1 1 0 0 0 2 0V2a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1zm3 15H3V5h6a1 1 0 1 0 0-2H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12c1.1 0 2-.9 2-2v-6a1 1 0 0 0-2 0v6z',
    size: 20,
  },
  '20-list-ordered': {
    path:
      'M7 4h11a1 1 0 0 0 0-2H7a1 1 0 1 0 0 2zm0 7h11a1 1 0 0 0 0-2H7a1 1 0 1 0 0 2zm-3 4.001V19H1v-1h2v-.5H2v-1h1v-.499H1v-1h3zM18 16a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2zM4 8v.9L2.201 11H4v1H1v-.9L2.8 9H1V8h3zM3 1v4.001H2V2H1V1h2z',
    size: 20,
  },
  '20-list-unordered': {
    path:
      'M7 4h11a1 1 0 0 0 0-2H7a1 1 0 1 0 0 2zm0 7h11a1 1 0 0 0 0-2H7a1 1 0 1 0 0 2zm-4.5 4.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zM18 16a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2zM2.5 8.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm0-7a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3z',
    size: 20,
  },
  '20-liveblog': {
    path:
      'M17 1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H5l-4 3V3a2 2 0 0 1 2-2h14zm0 2H3v12l1.333-1H17V3zM6 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm8 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm-4-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2z',
    size: 20,
  },
  '20-lock': {
    path:
      'M10 12a1 1 0 0 1 1 1v1a1 1 0 0 1-2 0v-1a1 1 0 0 1 1-1zM4 8c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-7c0-1.1-.9-2-2-2H4zm12 2v7H4v-7h12zm-6-9a5 5 0 0 1 5 5v2h-2V6a3 3 0 0 0-5.995-.176L7 6v2H5V6a5 5 0 0 1 5-5z',
    size: 20,
  },
  '20-mac': {
    path:
      'M10.953 6.348c.967-.332 1.552-.427 2.399-.302l.254.043c1.25.242 2.222.856 2.844 1.815a1 1 0 01-.307 1.392c-.839.525-1.226 1.167-1.146 2.122.047.574.534 1.226 1.566 1.929a1 1 0 01.353 1.228c-.503 1.147-.941 1.98-1.337 2.518l-.316.425c-.73.943-1.471 1.467-2.55 1.467-.515 0-.883-.097-1.498-.332l-.341-.126c-.246-.085-.388-.114-.554-.117-.288-.004-.494.047-.954.222l-.264.099a4.47 4.47 0 01-.989.26L7.976 19h-.299l-.141-.01c-.857-.122-1.518-.618-2.167-1.394C4 15.955 3.166 14.012 3 11.687v-.692c.08-1.844.988-3.471 2.366-4.299.852-.516 1.807-.77 2.804-.62.394.06.781.174 1.25.349l.48.194.117.037.066.013c-.003 0-.002 0 0-.002l.427-.161zm1.982 1.66c-.363-.036-.67.013-1.194.185l-.385.134-.45.17c-.278.105-.5.164-.765.171a2.035 2.035 0 01-.433-.034 3.373 3.373 0 01-.74-.234l-.188-.078-.262-.096a3.824 3.824 0 00-.648-.173c-.483-.072-.986.062-1.472.356C5.612 8.88 5.05 9.888 5 11.039l-.003.576c.133 1.82.797 3.369 1.907 4.698.36.43.668.662.914.697L7.773 17h.122l.12-.023.192-.053.24-.084.453-.168c.542-.192.925-.27 1.453-.261.524.009.875.105 1.521.353l.196.073.23.079c.168.05.285.07.412.07.313 0 .58-.19.969-.692l.287-.386c.192-.262.425-.669.691-1.214l.097-.204-.212-.182c-.863-.77-1.382-1.604-1.516-2.513l-.025-.212c-.107-1.285.285-2.334 1.056-3.154l.057-.059-.163-.086a2.96 2.96 0 00-.694-.225l-.201-.035zM13.985 1c.113 1.221-.42 2.134-1.066 2.794-.634.656-1.503 1.293-2.908 1.196-.094-1.203.387-2.104 1.085-2.707C12 1.5 13 1 13.985 1z',
    size: 20,
  },
  '20-maximize': {
    path:
      'M18 12c.513 0 .936.386.993.883L19 13v4c0 1.054-.816 1.918-1.85 1.995L17 19h-4c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L13 17h4v-4c0-.552.448-1 1-1zM2 12c.552 0 1 .448 1 1v4h4l.117.007c.497.057.883.48.883.993 0 .552-.448 1-1 1H3l-.15-.005C1.817 18.918 1 18.055 1 17v-4l.007-.117c.057-.497.48-.883.993-.883zM7 1c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L7 3H3v4c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L1 7V3c0-1.054.816-1.918 1.85-1.995L3 1h4zm10 0l.15.005C18.183 1.082 19 1.945 19 3v4l-.007.117c-.057.497-.48.883-.993.883-.552 0-1-.448-1-1V3h-4l-.117-.007C12.386 2.936 12 2.513 12 2c0-.552.448-1 1-1h4z',
    size: 20,
  },
  '20-megaphone': {
    path:
      'M17,12.8981 C17,13.2311 16.863,13.5411 16.625,13.7501 C16.424,13.9271 16.174,14.0121 15.916,13.9861 L7,12.0451 L7,5.9911 C7,5.9731 6.991,5.9581 6.99,5.9401 L15.882,3.9991 C16.151,3.9631 16.415,4.0461 16.625,4.2311 C16.863,4.4401 17,4.7511 17,5.0841 L17,12.8981 Z M9,14.6771 C9,15.1531 8.809,15.5811 8.488,15.8211 C8.34,15.9321 8.104,16.0471 7.786,15.9541 C7.331,15.8221 7,15.2821 7,14.6711 L7,14.0901 L9.029,14.5321 C9.022,14.5821 9,14.6261 9,14.6771 L9,14.6771 Z M3,10.2821 L3,7.6991 C3,7.1471 3.379,6.6801 3.965,6.6001 L5,6.3741 L5,11.6101 L3.881,11.3671 C3.379,11.3011 3,10.8351 3,10.2821 L3,10.2821 Z M17.945,2.7291 C17.304,2.1661 16.459,1.9061 15.539,2.0301 L3.623,4.6311 C2.127,4.8271 1,6.1461 1,7.6991 L1,10.2821 C1,11.8361 2.127,13.1541 3.539,13.3351 L5,13.6541 L5,14.6711 C5,16.1761 5.917,17.4941 7.248,17.8811 C7.5,17.9541 7.756,17.9901 8.012,17.9901 C8.604,17.9901 9.189,17.7951 9.688,17.4211 C10.439,16.8571 10.893,15.9481 10.969,14.9551 L15.539,15.9511 L15.622,15.9661 C15.748,15.9821 15.873,15.9901 15.999,15.9901 C16.707,15.9901 17.4,15.7311 17.945,15.2531 C18.615,14.6651 19,13.8061 19,12.8981 L19,5.0841 C19,4.1751 18.615,3.3171 17.945,2.7291 L17.945,2.7291 Z',
    size: 20,
  },

  '20-mention-add': {
    path:
      'M12 17v2H8v-2h4zm-9-3v3h3v2H3c-1.105 0-2-.895-2-2v-3h2zm13.5 0c1.38 0 2.5 1.12 2.5 2.5S17.88 19 16.5 19 14 17.88 14 16.5s1.12-2.5 2.5-2.5zM19 8v4h-2V8h2zM3 8v4H1V8h2zm14-7c1.105 0 2 .895 2 2v3h-2V3h-3V1h3zM6 1v2H3v3H1V3c0-1.105.895-2 2-2h3zm6 0v2H8V1h4z',
    size: 20,
  },
  '20-minimize': {
    path:
      'M18 12c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L18 14h-4v4c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L12 18v-4c0-1.054.816-1.918 1.85-1.995L14 12h4zM6 12l.15.005C7.183 12.082 8 12.945 8 14v4l-.007.117c-.057.497-.48.883-.993.883-.552 0-1-.448-1-1v-4H2l-.117-.007C1.386 13.936 1 13.513 1 13c0-.552.448-1 1-1h4zM7 1c.513 0 .936.386.993.883L8 2v4c0 1.054-.816 1.918-1.85 1.995L6 8H2c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L2 6h4V2c0-.552.448-1 1-1zm6 0c.552 0 1 .448 1 1v4h4l.117.007c.497.057.883.48.883.993 0 .552-.448 1-1 1h-4l-.15-.005C12.817 7.918 12 7.055 12 6V2l.007-.117c.057-.497.48-.883.993-.883z',
    size: 20,
  },
  '20-minus': {
    path: 'M3 10a1 1 0 0 0 1 1h12a1 1 0 0 0 0-2H4a1 1 0 0 0-1 1z',
    size: 20,
  },
  '20-mobile': {
    path:
      'M17 17a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v14zM15 3H5v14h10V3zm-4 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0z',
    size: 20,
  },
  '20-more-horizontal': {
    path:
      'M8 10c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2zm7 0c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2zM1 10c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2z',
    size: 20,
  },
  '20-more-vertical': {
    path:
      'M12 10c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2m0 7c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2m0-14c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2',
    size: 20,
  },
  '20-n-2-cr': {
    path:
      'M16 11.002c1.654 0 3 1.346 3 3 0 .976-.468 1.844-1.192 2.392l.9.901c.39.391.39 1.024-.001 1.415-.361.36-.928.387-1.32.082l-.095-.083-1.703-1.707H13v1c0 .55-.45 1-1 1-.51 0-.935-.388-.993-.884L11 18.002v-6c0-.51.388-.935.884-.993l.116-.007h4zm-10.523 0c1.213 0 2.357.433 3.196 1.196.408.372.438 1.004.067 1.413-.343.377-.909.431-1.315.145l-.098-.079c-.466-.424-1.13-.675-1.85-.675-1.398 0-2.477.93-2.477 2 0 1.07 1.079 2 2.477 2 .67 0 1.292-.217 1.753-.592.428-.348 1.058-.283 1.406.146.349.429.283 1.058-.145 1.407-.82.666-1.888 1.039-3.014 1.039-2.442 0-4.477-1.755-4.477-4s2.035-4 4.477-4zm10.523 2h-3v2h2.925c.036-.003.072-.004.109-.002.535-.016.966-.458.966-.998 0-.551-.449-1-1-1zM2.623 1.219l.084.076L7 5.587V2.002c0-.513.386-.936.883-.993L8 1.002c.513 0 .936.386.993.883L9 2.002v6c0 .852-.986 1.297-1.623.783l-.084-.076L3 4.417v3.585c0 .513-.386.936-.883.993L2 9.002c-.513 0-.936-.386-.993-.883L1 8.002v-6c0-.852.986-1.297 1.623-.783zM14.8 1c2.408 0 3.799.955 3.799 2.368 0 .994-.598 1.536-1.976 2.485l-.224.153-1.367.995h2.968c.513 0 .936.386.993.883l.007.117-.005.075.004.06c0 .378-.223.668-.631.794-.08.033-.164.054-.251.064L18 9.001h-6c-.353 0-.636-.169-.81-.412-.104-.127-.164-.279-.184-.447l-.005-.089-.002-.1c.008-.2.077-.4.218-.575l.076-.084.022-.003c.091-.095.204-.19.338-.287l.142-.097L14.8 5c1.112-.75 1.299-1.017 1.299-1.48 0-.492-.633-.832-1.34-.832-.737 0-1.217.533-1.333.831-.116.299-.821.358-1.069.358-.74 0-1.028-.315-1.028-.865 0-.178.04-.345.13-.507C11.981 1.577 13.072 1 14.801 1z',
    size: 20,
  },
  '20-o2-solid': {
    path:
      'M16 0a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h12zM6.986 5c-.748 0-1.432.119-2.051.356a4.43 4.43 0 0 0-1.583 1.013A4.43 4.43 0 0 0 2.35 7.955 5.76 5.76 0 0 0 2 10c0 .739.115 1.413.345 2.023.23.61.567 1.138 1.012 1.585.445.448.97.791 1.578 1.032.607.24 1.29.36 2.051.36.767 0 1.457-.119 2.07-.356a4.477 4.477 0 0 0 1.582-1.022 4.463 4.463 0 0 0 1.012-1.595c.233-.619.35-1.294.35-2.027 0-.739-.115-1.414-.345-2.027a4.426 4.426 0 0 0-1.007-1.586A4.511 4.511 0 0 0 9.056 5.36c-.62-.24-1.31-.36-2.07-.36zm0 1.82c.76 0 1.366.28 1.817.838.45.558.676 1.339.676 2.342 0 .991-.225 1.767-.676 2.329-.45.561-1.056.842-1.817.842-.503 0-.94-.127-1.31-.383-.372-.255-.657-.623-.856-1.103-.2-.48-.3-1.042-.3-1.685 0-.649.102-1.216.304-1.703.203-.486.49-.854.865-1.103a2.28 2.28 0 0 1 1.297-.374zM15.48 5c-.54 0-.996.088-1.367.264-.371.176-.647.399-.827.668-.18.27-.27.535-.27.796 0 .181.06.327.183.436a.65.65 0 0 0 .453.164c.212 0 .36-.047.445-.14.085-.093.184-.256.298-.488a1.52 1.52 0 0 1 .39-.524c.145-.117.367-.176.663-.176.281 0 .51.068.688.204a.663.663 0 0 1 .266.556c0 .219-.08.419-.242.6-.162.181-.44.41-.835.684l-.648.452c-.429.33-.75.584-.962.76-.212.176-.384.35-.516.524a.889.889 0 0 0-.199.548c0 .181.074.339.223.472.123.111.29.176.497.194l.13.006h3.45l.13-.007a.648.648 0 0 0 .391-.165.543.543 0 0 0 .179-.404.498.498 0 0 0-.219-.428.933.933 0 0 0-.469-.15l-.155-.006h-2.202l.065-.068c.19-.19.544-.456 1.06-.8.58-.387 1.027-.744 1.34-1.072.312-.328.469-.713.469-1.156 0-.485-.199-.897-.596-1.236C16.895 5.169 16.29 5 15.48 5z',
    size: 20,
  },
  '20-object-hide': {
    path:
      'M17 1c1.105 0 2 .895 2 2v8h-2.001L17 3H3v14h8v2H3c-1.105 0-2-.895-2-2V3c0-1.105.895-2 2-2h14zm-3.707 12.293c.391-.39 1.023-.39 1.414 0L16 14.586l1.293-1.293c.391-.39 1.023-.39 1.414 0 .391.391.391 1.023 0 1.414L17.414 16l1.293 1.293c.391.391.391 1.023 0 1.414-.195.195-.45.293-.707.293-.256 0-.512-.098-.707-.293L16 17.414l-1.293 1.293c-.195.195-.45.293-.707.293-.256 0-.512-.098-.707-.293-.39-.39-.39-1.023 0-1.414L14.586 16l-1.293-1.293c-.39-.39-.39-1.023 0-1.414zM11 11v4H5c0-2.21 1.79-4 4-4h2zm-1-6c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2z',
    size: 20,
  },
  '20-object-maximize': {
    path:
      'M18 12c.513 0 .936.386.993.883L19 13v4c0 1.054-.816 1.918-1.85 1.995L17 19h-4c-.552 0-1-.448-1-1 0-.513.386-.936.883-.993L13 17h4v-4c0-.552.448-1 1-1zM2 12c.552 0 1 .448 1 1v4h4l.117.007c.497.057.883.48.883.993 0 .552-.448 1-1 1H3l-.15-.005C1.817 18.918 1 18.055 1 17v-4l.007-.117c.057-.497.48-.883.993-.883zm9-1c2.142 0 3.891 1.684 3.995 3.8L15 15H5c0-2.21 1.79-4 4-4h2zm-1-6c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2zM7 1c.552 0 1 .448 1 1 0 .513-.386.936-.883.993L7 3H3v4c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L1 7V3c0-1.054.816-1.918 1.85-1.995L3 1h4zm10 0l.15.005C18.183 1.082 19 1.945 19 3v4l-.007.117c-.057.497-.48.883-.993.883-.552 0-1-.448-1-1V3h-4l-.117-.007C12.386 2.936 12 2.513 12 2c0-.552.448-1 1-1h4z',
    size: 20,
  },
  '20-object-mention': {
    path:
      'M17 1c1.105 0 2 .895 2 2v11c0 1.105-.895 2-2 2h-3.819L10 19l-3.182-3H3c-1.105 0-2-.895-2-2V3c0-1.105.895-2 2-2h14zm0 2H3v11h4.612L10 16.251 12.387 14H17V3zm-6 6c1.598 0 2.904 1.249 2.995 2.824L14 12H6c0-1.657 1.343-3 3-3h2zm-1-5c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2z',
    size: 20,
  },
  '20-object-show': {
    path:
      'M17 1c1.105 0 2 .895 2 2v14c0 1.105-.895 2-2 2H3c-1.105 0-2-.895-2-2V3c0-1.105.895-2 2-2h14zm0 2H3v14h14V3zm-6 8c2.142 0 3.891 1.684 3.995 3.8L15 15H5c0-2.21 1.79-4 4-4h2zm-1-6c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2z',
    size: 20,
  },
  '20-pako': {
    path:
      'M15,11 C17.206,11 19,12.794 19,15 C19,17.206 17.206,19 15,19 C12.794,19 11,17.206 11,15 C11,12.794 12.794,11 15,11 Z M1.9998,10.9999 C2.5518,10.9999 2.9998,11.4479 2.9998,11.9999 L2.9998,11.9999 L2.9998,13.7499 L6.3998,11.1999 C6.8438,10.8689 7.4698,10.9589 7.7998,11.3999 C8.1318,11.8419 8.0418,12.4689 7.5998,12.7999 L7.5998,12.7999 L4.6668,14.9999 L7.5998,17.1999 C8.0418,17.5309 8.1318,18.1579 7.7998,18.5999 C7.6038,18.8619 7.3028,18.9999 6.9988,18.9999 C6.7908,18.9999 6.5798,18.9349 6.3998,18.7999 L6.3998,18.7999 L2.9998,16.2499 L2.9998,17.9999 C2.9998,18.5519 2.5518,18.9999 1.9998,18.9999 C1.4478,18.9999 0.9998,18.5519 0.9998,17.9999 L0.9998,17.9999 L0.9998,11.9999 C0.9998,11.4479 1.4478,10.9999 1.9998,10.9999 Z M15,13 C13.897,13 13,13.897 13,15 C13,16.103 13.897,17 15,17 C16.103,17 17,16.103 17,15 C17,13.897 16.103,13 15,13 Z M5,1 C6.654,1 8,2.346 8,4 C8,5.654 6.654,7 5,7 L5,7 L3,7 L3,8 C3,8.55 2.55,9 2,9 C1.45,9 1,8.55 1,8 L1,8 L1,2 C1,1.45 1.45,1 2,1 L2,1 Z M14.105,1.5528 C14.445,0.8748 15.555,0.8748 15.895,1.5528 L15.895,1.5528 L18.895,7.5528 C19.142,8.0468 18.941,8.6478 18.447,8.8948 C18.304,8.9658 18.151,8.9998 18.001,8.9998 C17.634,9.0008 17.281,8.7978 17.105,8.4468 L17.105,8.4468 L16.882,7.9998 L13.118,7.9998 L12.895,8.4468 C12.647,8.9418 12.047,9.1408 11.553,8.8948 C11.059,8.6478 10.858,8.0468 11.105,7.5528 L11.105,7.5528 Z M15,4.2358 L14.118,5.9998 L15.882,5.9998 L15,4.2358 Z M5,3 L3,3 L3,5 L5,5 C5.551,5 6,4.551 6,4 C6,3.449 5.551,3 5,3 L5,3 Z',
    size: 20,
  },
  '20-paper-plane': {
    path:
      'M2.31401 2.27245C2.61933 1.98456 3.07191 1.91792 3.44725 2.10559L17.4472 9.10559C17.786 9.27499 18 9.62125 18 10C18 10.3788 17.786 10.7251 17.4472 10.8944L3.44725 17.8944C3.07191 18.0821 2.61933 18.0155 2.31401 17.7276C2.00868 17.4397 1.91559 16.9918 2.08089 16.6061L4.91207 10L2.08089 3.39394C1.91559 3.00823 2.00868 2.56034 2.31401 2.27245ZM6.65943 11L4.99456 14.8847L14.764 10L4.99456 5.11532L6.65943 9.00002H8.00004C8.55232 9.00002 9.00004 9.44774 9.00004 10C9.00004 10.5523 8.55232 11 8.00004 11H6.65943Z',
    size: 20,
  },
  '20-pause': {
    path:
      'M13 4c.552 0 1 .448 1 1v10c0 .552-.448 1-1 1s-1-.448-1-1V5c0-.552.448-1 1-1zM7 4c.552 0 1 .448 1 1v10c0 .552-.448 1-1 1s-1-.448-1-1V5c0-.552.448-1 1-1z',
    size: 20,
  },
  '20-play': {
    path: 'M5 3v14l12-7z',
    size: 20,
  },
  '20-plus': {
    path:
      'M9 4v5H4a1 1 0 1 0 0 2h5v5a1 1 0 0 0 2 0v-5h5a1 1 0 0 0 0-2h-5V4a1 1 0 0 0-2 0z',
    size: 20,
  },
  '20-plus-minus': {
    path:
      'M17 1a2 2 0 012 2v14a2 2 0 01-2 2H3a2 2 0 01-2-2V3a2 2 0 012-2h14zm0 2H3v14h14V3zM8 13h4a1 1 0 010 2H8a1 1 0 010-2zm2-8a1 1 0 011 1v1h1a1 1 0 010 2h-1v1a1 1 0 01-2 0V8.999L8 9a1 1 0 010-2l1-.001V6a1 1 0 011-1z',
    size: 20,
  },
  '20-praca-money': {
    path:
      'M10.613 1.21l.094.083 8 8a1 1 0 01.083 1.32l-.083.094-8 8a1 1 0 01-1.497-1.32l.083-.094L16.585 10 9.293 2.707a1 1 0 01-.083-1.32l.083-.094a1 1 0 011.32-.083zm-4 2l.094.083 6 6a1 1 0 01.083 1.32l-.083.094-6 6a1 1 0 01-1.497-1.32l.083-.094L10.585 10 5.293 4.707a1 1 0 01-.083-1.32l.083-.094a1 1 0 011.32-.083zm-4 2l.094.083 4 4a1 1 0 01.083 1.32l-.083.094-4 4a1 1 0 01-1.497-1.32l.083-.094L4.585 10 1.293 6.707a1 1 0 01-.083-1.32l.083-.094a1 1 0 011.32-.083z',
    size: 20,
  },
  '20-product': {
    path:
      'M9,5.2c0-0.4-0.3-0.6-0.6-0.6C8,4.5,7.7,4.8,7.7,5.2v2.6c0,0.4,0.3,0.6,0.6,0.6C8.7,8.4,9,8.1,9,7.8V5.2z' +
      'M11,4.5c0.4,0,0.6,0.3,0.6,0.6v2.6c0,0.4-0.3,0.6-0.6,0.6c-0.4,0-0.6-0.3-0.6-0.6V5.2C10.3,4.8,10.6,4.5,11,4.5z' +
      'M14.2,5.2c0-0.4-0.3-0.6-0.6-0.6s-0.6,0.3-0.6,0.6v2.6c0,0.4,0.3,0.6,0.6,0.6s0.6-0.3,0.6-0.6V5.2z' +
      'M0.6,1.3c0-0.4,0.3-0.6,0.6-0.6h2c0.6,0,1.2,0.5,1.3,1.1l0,0.2h12.7c0.8,0,1.4,0.6,1.3,1.4l-0.5,5.8c-0.1,0.6-0.5,1.1-1.1,1.2L6.2,11.6l0.1,0.7h7.8c0.4,0,0.6,0.3,0.6,0.6s-0.3,0.6-0.6,0.6H6.3c-0.6,0-1.2-0.5-1.3-1.1L3.3,2h-2C0.9,2,0.6,1.7,0.6,1.3z M6,10.3l-1.2-7h12.5l-0.5,5.8L6,10.3z' +
      'M6.4,18.7c1.1,0,1.9-0.9,1.9-1.9c0-1.1-0.9-1.9-1.9-1.9c-1.1,0-1.9,0.9-1.9,1.9C4.5,17.8,5.4,18.7,6.4,18.7z M6.4,17.4c0.4,0,0.6-0.3,0.6-0.6c0-0.4-0.3-0.6-0.6-0.6s-0.6,0.3-0.6,0.6C5.8,17.1,6.1,17.4,6.4,17.4z' +
      'M14.8,16.8c0,1.1-0.9,1.9-1.9,1.9S11,17.8,11,16.8c0-1.1,0.9-1.9,1.9-1.9S14.8,15.7,14.8,16.8z M13.5,16.8c0,0.4-0.3,0.6-0.6,0.6s-0.6-0.3-0.6-0.6c0-0.4,0.3-0.6,0.6-0.6S13.5,16.4,13.5,16.8z',
    size: 20,
  },
  '20-properties': {
    path:
      'M6 1c1.306 0 2.418.835 2.83 2H18a1 1 0 010 2H8.829a3 3 0 01-5.658 0H2a1 1 0 010-2h1.17A3.005 3.005 0 016 1zm0 2a1 1 0 100 2 1 1 0 000-2zm8 4c1.306 0 2.418.835 2.83 2H18a1 1 0 010 2h-1.171a3 3 0 01-5.658 0H2a1 1 0 010-2h9.17A3.003 3.003 0 0114 7zm0 2a1 1 0 100 2 1 1 0 000-2zm-8 4c1.306 0 2.418.835 2.83 2H18a1 1 0 010 2H8.829a3 3 0 01-5.658 0H2a1 1 0 010-2h1.17A3.003 3.003 0 016 13zm0 2a1 1 0 100 2 1 1 0 000-2z',
    size: 20,
  },
  '20-question-solid': {
    path:
      'M10 1c4.97 0 9 4.03 9 9s-4.03 9-9 9-9-4.03-9-9 4.03-9 9-9zm0 12c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1zm0-8C8.343 5 7 6.343 7 8c0 .552.448 1 1 1s1-.448 1-1l.007-.117C9.064 7.386 9.487 7 10 7c.552 0 1 .448 1 1s-.448 1-1 1l-.117.007C9.386 9.064 9 9.487 9 10v1l.007.117c.057.497.48.883.993.883l.117-.007c.497-.057.883-.48.883-.993v-.171l.183-.071C12.252 10.298 13 9.237 13 8c0-1.657-1.343-3-3-3z',
    size: 20,
  },
  '20-question-stroke': {
    path:
      'M10 1c4.97 0 9 4.03 9 9s-4.03 9-9 9-9-4.03-9-9 4.03-9 9-9zm0 2c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zm0 5c.513 0 .936.386.993.883L11 9v1c0 .513-.386.936-.883.993L10 11c-.552 0-1 .448-1 1s.448 1 1 1c.513 0 .936-.386.993-.883L11 12c0-.552.448-1 1-1s1 .448 1 1c0 1.657-1.343 3-3 3s-3-1.343-3-3c0-1.237.748-2.299 1.817-2.758L9 9.171V9c0-.513.386-.936.883-.993L10 8zm0-3c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z',
    size: 20,
  },
  '20-quote': {
    path:
      'M16 1a3 3 0 0 1 3 3v8c0 3.83-2.642 7-6 7a1 1 0 0 1-.117-1.993L13 17l.185-.005c2.02-.118 3.71-2.148 3.81-4.75L17 12h-3a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3h2zM6 1a3 3 0 0 1 3 3v8c0 3.83-2.642 7-6 7a1 1 0 0 1-.117-1.993L3 17l.185-.005c2.02-.118 3.71-2.148 3.81-4.75L7 12H4a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3h2zm10 2h-2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h3V4a1 1 0 0 0-1-1zM6 3H4a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h3V4a1 1 0 0 0-1-1z',
    size: 20,
  },
  '20-rating-star': {
    path:
      'M14.3,17.8c-0.2,0-0.3-0.1-0.5-0.2l-3.8-3l-3.8,3c-0.3,0.2-0.7,0.2-0.9,0C5,17.5,4.9,17.1,5,16.8l1.4-5.1L2.6,9.1\n' +
      '\t\tC2.3,8.9,2.2,8.6,2.3,8.2C2.4,7.9,2.7,7.7,3,7.6l4.8-0.3l1.4-4.6C9.3,2.4,9.6,2.2,10,2.2s0.7,0.2,0.8,0.6l1.4,4.6L17,7.6\n' +
      '\t\tc0.3,0,0.6,0.3,0.7,0.6s0,0.7-0.3,0.9l-3.8,2.6l1.4,5.1c0.1,0.3,0,0.7-0.3,0.9C14.6,17.7,14.4,17.8,14.3,17.8z M9.8,3.1\n' +
      '\t\tC9.8,3.1,9.8,3.1,9.8,3.1L9.8,3.1z',
    size: 20,
  },
  '20-rating-star-empty': {
    path:
      'M14.3,17.8c-0.2,0-0.3-0.1-0.5-0.2l-3.8-3l-3.8,3c-0.3,0.2-0.7,0.2-0.9,0C5,17.5,4.9,17.1,5,16.8l1.4-5.1L2.6,9.1\n' +
      '\t\tC2.3,8.9,2.2,8.6,2.3,8.2C2.4,7.9,2.7,7.7,3,7.6l4.8-0.3l1.4-4.6C9.3,2.4,9.6,2.2,10,2.2s0.7,0.2,0.8,0.6l1.4,4.6L17,7.6\n' +
      '\t\tc0.3,0,0.6,0.3,0.7,0.6s0,0.7-0.3,0.9l-3.8,2.6l1.4,5.1c0.1,0.3,0,0.7-0.3,0.9C14.6,17.7,14.4,17.8,14.3,17.8z M3.7,8.6L7.1,11\n' +
      '\t\tc0.3,0.2,0.4,0.5,0.3,0.9l-1.3,4.6l3.4-2.7c0.3-0.2,0.7-0.2,1,0l3.4,2.7l-1.3-4.6c-0.1-0.3,0-0.7,0.3-0.9l3.4-2.4L12,8.3\n' +
      '\t\tc-0.3,0-0.6-0.2-0.7-0.6L10,3.7L8.7,7.8C8.6,8.1,8.4,8.3,8,8.3L3.7,8.6z M9.8,3.1C9.8,3.1,9.8,3.1,9.8,3.1L9.8,3.1z',
    size: 20,
  },
  '20-reset': {
    path:
      'M7.387 1.21c.392-.305.96-.278 1.32.083l.083.094c.305.392.278.96-.083 1.32L8.414 3H10l.25.004C14.551 3.135 18 6.665 18 11c0 4.418-3.582 8-8 8s-8-3.582-8-8c0-.552.448-1 1-1s1 .448 1 1c0 3.314 2.686 6 6 6s6-2.686 6-6-2.686-6-6-6H8.414l.293.293.083.094c.305.392.278.96-.083 1.32-.39.39-1.024.39-1.414 0l-2-2-.083-.094c-.305-.392-.278-.96.083-1.32l2-2z',
    size: 20,
  },
  '20-rotate-left': {
    path:
      'M10 1c4.963 0 9 4.037 9 9s-4.037 9-9 9a1 1 0 110-2c3.859 0 7-3.141 7-7s-3.141-7-7-7a6.973 6.973 0 00-5.726 3H5a1 1 0 110 2H2a1 1 0 01-1-1V4a1 1 0 112 0v.354A8.977 8.977 0 0110 1zM5.77 16.86c.22-.5.82-.72 1.32-.49a1.003 1.003 0 01-.42 1.91.998.998 0 01-.9-1.42zM3 13.99c.439-.33 1.06-.24 1.399.2a.995.995 0 01-.21 1.4.931.931 0 01-.589.2c-.31 0-.61-.14-.81-.4h.01a.985.985 0 01.2-1.4zm-1.06-3.84a1 1 0 01.28 1.981c-.05.01-.09.01-.14.01a1 1 0 01-.14-1.991z',
    size: 20,
  },
  '20-rotate-right': {
    path:
      'M10 1c-4.963 0-9 4.037-9 9s4.037 9 9 9a1 1 0 100-2c-3.859 0-7-3.141-7-7s3.141-7 7-7a6.973 6.973 0 015.726 3H15a1 1 0 100 2h3a1 1 0 001-1V4a1 1 0 10-2 0v.354A8.977 8.977 0 0010 1zm4.23 15.86a.992.992 0 00-1.32-.49 1.003 1.003 0 00.42 1.91.998.998 0 00.9-1.42zM17 13.99a1.003 1.003 0 00-1.399.2.995.995 0 00.21 1.4c.169.14.389.2.589.2.31 0 .61-.14.81-.4h-.01a.985.985 0 00-.2-1.4zm1.06-3.84a1 1 0 00-.28 1.981c.05.01.09.01.14.01a1 1 0 00.14-1.991z',
    size: 20,
  },
  '20-scale': {
    path:
      'M3 14v3h4v2H3c-1.105 0-2-.895-2-2v-3h2zm7-9c.553 0 1 .448 1 1 0 .513-.385.935-.883.993L10 7H8.414l2 2H17c1.105 0 2 .895 2 2v6c0 1.105-.895 2-2 2h-6c-1.105 0-2-.895-2-2v-6.586l-2-2V10c0 .553-.448 1-1 1-.512 0-.935-.385-.993-.883L5 10V6c0-.13.027-.26.077-.382.102-.244.296-.439.541-.541.081-.034.166-.057.252-.068L6 5h4zm7 6h-6v6h6v-6zM3 8v4H1V8h2zm14-7c1.105 0 2 .895 2 2v4h-2V3h-3V1h3zM6 1v2H3v3H1V3c0-1.105.895-2 2-2h3zm6 0v2H8V1h4z',
    size: 20,
  },
  '20-search': {
    path:
      'M3 8c0-2.757 2.243-5 5-5s5 2.243 5 5-2.243 5-5 5-5-2.243-5-5m15.707 9.293l-5.106-5.106C14.476 11.018 15 9.572 15 8c0-3.866-3.134-7-7-7S1 4.134 1 8s3.134 7 7 7c1.572 0 3.018-.524 4.187-1.399l5.106 5.106c.195.195.451.293.707.293.256 0 .512-.098.707-.293.391-.391.391-1.023 0-1.414',
    size: 20,
  },
  '20-settings': {
    path:
      'M11 1a1 1 0 0 1 1 1v.252c.734.19 1.427.48 2.064.856l.179-.18a1 1 0 0 1 1.414 0l1.414 1.415a1 1 0 0 1 0 1.414l-.179.179c.377.637.667 1.33.856 2.065L18 8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-.252a7.952 7.952 0 0 1-.856 2.064l.18.179a1 1 0 0 1 0 1.414l-1.415 1.414a1 1 0 0 1-1.414 0l-.179-.179a7.952 7.952 0 0 1-2.064.856V18a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-.252a7.952 7.952 0 0 1-2.064-.856l-.179.18a1 1 0 0 1-1.414 0L2.93 15.656a1 1 0 0 1 0-1.414l.179-.179A7.952 7.952 0 0 1 2.252 12H2a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h.252c.189-.734.48-1.427.856-2.064l-.18-.179a1 1 0 0 1 0-1.414L4.344 2.93a1 1 0 0 1 1.414 0l.179.179a7.952 7.952 0 0 1 2.065-.856L8 2a1 1 0 0 1 1-1h2zm-1 2a1 1 0 0 0-.997 1.084A5.946 5.946 0 0 0 6.52 5.112l-.055-.062a1 1 0 1 0-1.352 1.47 5.961 5.961 0 0 0-1.03 2.484L4 9a1 1 0 1 0 .084 1.997c.151.914.511 1.759 1.028 2.484l-.062.055a1 1 0 1 0 1.47 1.352 5.961 5.961 0 0 0 2.484 1.03L9 16a1 1 0 0 0 1 1l.117-.007A1 1 0 0 0 11 16l-.003-.084a5.942 5.942 0 0 0 2.484-1.028l.055.062a1 1 0 1 0 1.352-1.47 5.961 5.961 0 0 0 1.03-2.484L16 11a1 1 0 1 0-.084-1.997 5.942 5.942 0 0 0-1.028-2.484l.062-.055a1 1 0 1 0-1.47-1.352 5.961 5.961 0 0 0-2.484-1.03L11 4a1 1 0 0 0-1-1zm0 3a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4z',
    size: 20,
  },
  '20-share': {
    path:
      'M15.5 1a3.5 3.5 0 1 1-2.915 5.438L7.828 9.413C7.94 9.755 8 10.12 8 10.5l-.005.192 4.59 2.87A3.5 3.5 0 1 1 12 15.554l-4.709-2.943a3.5 3.5 0 1 1-.606-4.844l5.315-3.322.004-.137A3.5 3.5 0 0 1 15.5 1zm0 13a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-11-5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm11-6a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z',
    size: 20,
  },
  '20-signal': {
    path:
      'M2 8.992c.553 0 1 .449 1 1.001-.002 3.634 2.777 6.66 6.377 6.973l.282.018.331-.002c.552 0 1 .448 1 1 0 .553-.448 1-1 1l-.394.001-.08-.003C4.732 18.728.998 14.77 1 9.992c0-.552.448-1 1-1zm3.99 0c.552 0 1 .448 1 1 0 1.657 1.343 3 3 3 .552 0 1 .448 1 1 0 .553-.448 1-1 1-2.761 0-5-2.238-5-5 0-.552.448-1 1-1zm4 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zM10.308 1c.054 0 .101.002.155.005 4.785.252 8.52 4.21 8.517 8.988 0 .552-.448 1-1 1-.553 0-1-.449-1-1.001.002-3.635-2.777-6.66-6.385-6.973L10.317 3l-.327.002c-.552 0-1-.447-1-1 0-.552.448-1 1-1L10.308 1zM9.99 4.992c2.761 0 5 2.24 5 5 0 .553-.448 1-1 1s-1-.447-1-1c0-1.656-1.343-3-3-3-.552 0-1-.447-1-1 0-.552.448-1 1-1z',
    size: 20,
  },
  '20-smile': {
    path:
      'M10 1c4.97 0 9 4.03 9 9s-4.03 9-9 9-9-4.03-9-9 4.03-9 9-9zm0 2c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zm-2 8c0 1.105.895 2 2 2 1.054 0 1.918-.816 1.995-1.85L12 11h2c0 2.21-1.79 4-4 4-2.142 0-3.891-1.684-3.995-3.8L6 11h2zm-.5-5C8.328 6 9 6.672 9 7.5S8.328 9 7.5 9 6 8.328 6 7.5 6.672 6 7.5 6zm5 0c.828 0 1.5.672 1.5 1.5S13.328 9 12.5 9 11 8.328 11 7.5 11.672 6 12.5 6z',
    size: 20,
  },
  '20-specification': {
    path:
      'M17 1a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14zm0 2H3v14h14V3zm-7 6a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1zm0-4a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0V6a1 1 0 0 1 1-1z',
    size: 20,
  },
  '20-sphere': {
    path:
      'M10 1c4.97 0 9 4.03 9 9s-4.03 9-9 9-9-4.03-9-9 4.03-9 9-9zm2.462 12.867l-.08.009c-.76.082-1.559.124-2.382.124-.852 0-1.679-.045-2.463-.133C8.114 15.77 9.07 17 10 17c.93 0 1.886-1.23 2.462-3.133zm-8.825-.943c.554 1.198 1.428 2.207 2.512 2.922-.324-.702-.587-1.497-.78-2.357-.63-.156-1.213-.345-1.732-.565zm12.725 0l-.01.005c-.517.218-1.095.405-1.722.56-.192.86-.455 1.655-.779 2.357 1.087-.717 1.962-1.73 2.511-2.923zM10 8c-1.035 0-2.014.082-2.894.218C7.038 8.785 7 9.382 7 10c0 .618.038 1.215.107 1.782.879.136 1.858.218 2.893.218 1.035 0 2.014-.082 2.894-.218.068-.567.106-1.164.106-1.782 0-.618-.038-1.215-.107-1.782C12.014 8.082 11.035 8 10 8zm-4.95.682l-.108.035C3.736 9.107 3 9.592 3 10c0 .42.78.922 2.05 1.317-.033-.43-.05-.87-.05-1.317 0-.447.017-.887.05-1.318zm9.9 0l.011.16c.026.38.039.766.039 1.158 0 .447-.017.887-.05 1.318C16.22 10.922 17 10.42 17 10c0-.42-.78-.922-2.05-1.317zM6.15 4.155l-.063.041c-1.058.715-1.91 1.711-2.448 2.882.518-.221 1.1-.41 1.732-.566.192-.86.455-1.655.779-2.357zm7.702 0l.056.124c.299.671.542 1.423.723 2.233.632.156 1.214.345 1.733.565-.55-1.193-1.425-2.205-2.512-2.922zM10 3l-.108.005c-.896.09-1.8 1.298-2.354 3.128C8.321 6.045 9.148 6 10 6l.307.002c.744.01 1.466.054 2.156.131C11.886 4.23 10.93 3 10 3z',
    size: 20,
  },
  '20-square-solid': {
    path:
      'M3,1 L17,1 C18.1045695,1 19,1.8954305 19,3 L19,17 C19,18.1045695 18.1045695,19 17,19 L3,19 C1.8954305,19 1,18.1045695 1,17 L1,3 C1,1.8954305 1.8954305,1 3,1 Z',
    size: 20,
  },
  '20-square-stroke': {
    path:
      'M17 1a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14zM3 3v14h14V3H3z',
    size: 20,
  },
  '20-table': {
    path:
      'M19 17a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14zM3 13.999V17h3v-3.001H3zm5 0V17h9v-3l-9-.001zm0-6v4L17 12V8l-9-.001zm-2 0H3v4h3v-4zM17 3H8v2.999L17 6V3zM6 3H3v2.999h3V3z',
    size: 20,
  },
  '20-table-complex': {
    path:
      'M19 17a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14zM3 10.999V17h4v-6.001H3zm6 0V17h8v-6l-8-.001zM17 3H9v5.999L17 9V3zM7 3H3v5.999h4V3z',
    size: 20,
  },
  '20-tablet': {
    path:
      'M16 1a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h12zm0 2H4v14h12V3zm-4 10a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2h4z',
    size: 20,
  },
  '20-tag': {
    path:
      'M15 16l-5-2.18L5 16V3h10v13zm0-15H5c-1.1 0-2 .9-2 2v16l7-3 7 3V3c0-1.1-.9-2-2-2z',
    size: 20,
  },
  '20-tags': {
    path:
      'M11 5a2 2 0 0 1 2 2v12l-5-3-5 3V7a2 2 0 0 1 2-2h6zm4-4a2 2 0 0 1 2 2v14l-2-.857V3H3a2 2 0 0 1 2-2h10zm-4 6H5v8.967l3-2.143 3 2.143V7z',
    size: 20,
  },
  '20-tech': {
    path:
      'M2 15a1 1 0 010-2h1l.001-2H2a1 1 0 010-2h1l.001-2H2a1 1 0 010-2h1a2 2 0 012-2V2a1 1 0 012 0v1h2V2a1 1 0 012 0v1h2V2a1 1 0 012 0v1a2 2 0 012 2h1a1 1 0 010 2h-1v2h1a1 1 0 010 2h-1v2h1a1 1 0 010 2h-1a2 2 0 01-2 2v1a1 1 0 01-2 0v-1h-2v1a1 1 0 01-2 0v-1H7v1a1 1 0 01-2 0v-1l-.15-.005A2.001 2.001 0 013 15H2zM15 5H5v10h10V5zm-4 3a1 1 0 011 1v2a1 1 0 01-1 1H9a1 1 0 01-1-1V9a1 1 0 011-1z',
    size: 20,
  },
  '20-templates': {
    path:
      'M7 1a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h4zm10 10a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h4zM7 3H3v14h4V3zm10 10h-4v4h4v-4zm0-12a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h4zm0 2h-4v4h4V3z',
    size: 20,
  },
  '20-test': {
    path:
      'M15.1,17.7V19H2.3C1.6,19,1,18.4,1,17.7V2.3C1,1.6,1.6,1,2.3,1h9h1.3l3.9,3.9v1.3v1.3h-1.3V6.1h-1.9c-1.1,0-1.9-0.9-1.9-1.9V2.3h-9v15.4H15.1z M12.6,2.8v1.4c0,0.4,0.3,0.6,0.6,0.6h1.4L12.6,2.8z M3.6,5.5c0-0.4,0.3-0.6,0.6-0.6h4.5c0.4,0,0.6,0.3,0.6,0.6S9.1,6.1,8.7,6.1H4.2C3.9,6.1,3.6,5.9,3.6,5.5z M4.2,7.4c-0.4,0-0.6,0.3-0.6,0.6c0,0.4,0.3,0.6,0.6,0.6h2.6c0.4,0,0.6-0.3,0.6-0.6c0-0.4-0.3-0.6-0.6-0.6H4.2z M3.6,13.2c0-0.4,0.3-0.6,0.6-0.6h1.3c0.4,0,0.6,0.3,0.6,0.6c0,0.4-0.3,0.6-0.6,0.6H4.2C3.9,13.9,3.6,13.6,3.6,13.2z M4.2,15.1c-0.4,0-0.6,0.3-0.6,0.6c0,0.4,0.3,0.6,0.6,0.6h2.6c0.4,0,0.6-0.3,0.6-0.6c0-0.4-0.3-0.6-0.6-0.6H4.2z M3.6,10.6c0-0.4,0.3-0.6,0.6-0.6h1.3c0.4,0,0.6,0.3,0.6,0.6c0,0.4-0.3,0.6-0.6,0.6H4.2C3.9,11.3,3.6,11,3.6,10.6z M11.9,8.7c-1.8,0-3.2,1.4-3.2,3.2s1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2S13.7,8.7,11.9,8.7z M15.5,14.6l3.3,3.3c0.3,0.3,0.3,0.7,0,0.9c-0.1,0.1-0.3,0.2-0.5,0.2s-0.3-0.1-0.5-0.2l-3.3-3.3c-0.8,0.6-1.7,0.9-2.7,0.9c-2.5,0-4.5-2-4.5-4.5s2-4.5,4.5-4.5s4.5,2,4.5,4.5C16.4,12.9,16.1,13.9,15.5,14.6z',
    size: 20,
  },
  '20-time': {
    path:
      'M10,19 C5.02943725,19 1,14.9705627 1,10 C1,5.02943725 5.02943725,1 10,1 C14.9705627,1 19,5.02943725 19,10 C19,14.9705627 14.9705627,19 10,19 Z M10,17 C13.8659932,17 17,13.8659932 17,10 C17,6.13400675 13.8659932,3 10,3 C6.13400675,3 3,6.13400675 3,10 C3,13.8659932 6.13400675,17 10,17 Z M10,5 C10.5522847,5 11,5.44771525 11,6 L11,11 L11,11 L10,11 C9.44771525,11 9,10.5522847 9,10 L9,6 C9,5.44771525 9.44771525,5 10,5 Z M11,9 L13,9 C13.5522847,9 14,9.44771525 14,10 C14,10.5522847 13.5522847,11 13,11 L11,11 L11,11 L11,9 Z',
    size: 20,
  },
  '20-timeline': {
    path:
      'M4 1c.552 0 1 .448 1 1v1.171C6.167 3.583 7 4.694 7 6c0 1.306-.834 2.417-2 2.829v2.342c1.166.412 2 1.523 2 2.829 0 1.306-.834 2.417-2 2.829V18c0 .552-.448 1-1 1s-1-.448-1-1v-1.17c-1.165-.412-2-1.524-2-2.83s.835-2.418 2-2.83V8.83C1.835 8.417 1 7.305 1 6s.835-2.418 2-2.83V2c0-.552.448-1 1-1zm13 10c1.105 0 2 .895 2 2v2c0 1.105-.895 2-2 2h-6c-1.105 0-2-.895-2-2v-2c0-1.105.895-2 2-2h6zM4 13c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1zm13 0h-6v2h6v-2zm0-10c1.105 0 2 .895 2 2v2c0 1.105-.895 2-2 2h-6c-1.105 0-2-.895-2-2V5c0-1.105.895-2 2-2h6zM4 5c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1zm13 0h-6v2h6V5z',
    size: 20,
  },
  '20-titles': {
    path:
      'M17 1a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2Zm0 2H3v14h14V3ZM6 7a1 1 0 1 1 0-2h8a1 1 0 0 1 0 2h-3v7a1 1 0 0 1-2 0V7H6Z',
    size: 20,
  },
  '20-user': {
    path:
      'M7 6c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3-3 1.346-3 3zM5 6c0-2.757 2.243-5 5-5s5 2.243 5 5-2.243 5-5 5-5-2.243-5-5zm5 13H1v-2c0-2.757 2.243-5 5-5h4v2H6c-1.654 0-3 1.346-3 3h7v2zm0 0h9v-2c0-2.757-2.243-5-5-5h-4v2h4c1.654 0 3 1.346 3 3h-7v2z',
    size: 20,
  },
  '20-user-add': {
    path:
      'M9 12v2H6c-1.654 0-3 1.346-3 3h6v2H1v-2c0-2.757 2.243-5 5-5h3zm6-1a1 1 0 0 1 .993.883L16 12v2h2a1 1 0 0 1 .117 1.993L18 16h-2v2a1 1 0 0 1-2 0v-2h-2l-.117-.007a1 1 0 0 1 0-1.986L12 14h2v-2l.007-.117A1 1 0 0 1 15 11zM10 1c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5zm0 2C8.346 3 7 4.346 7 6s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3z',
    size: 20,
  },
  '20-user-delete': {
    path:
      'M11 12v2H6c-1.654 0-3 1.346-3 3h8v2H1v-2c0-2.757 2.243-5 5-5h5zm2.293 1.293a.999.999 0 0 1 1.414 0L16 14.586l1.293-1.293a.999.999 0 1 1 1.414 1.414L17.414 16l1.293 1.293a.999.999 0 1 1-1.414 1.414L16 17.414l-1.293 1.293a.997.997 0 0 1-1.414 0 .999.999 0 0 1 0-1.414L14.586 16l-1.293-1.293a.999.999 0 0 1 0-1.414zM10 1c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5zm0 2C8.346 3 7 4.346 7 6s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3z',
    size: 20,
  },
  '20-user-edit': {
    path:
      'M15 12l2 2-5.219 5H10v-2l5-5zm3.07-2l.9.9c.041.491.041.817 0 .9l-.9.9-1.797-1.8.9-.9c.011.07.074.02.03.004l-.03-.004c.344 0 .51.081.897 0zM10 1c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5zm0 2C8.346 3 7 4.346 7 6s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zM9 19H1v-2c0-2.757 2.243-5 5-5h7l-2 2H6c-1.654 0-3 1.346-3 3h6v2z',
    size: 20,
  },
  '20-users': {
    path:
      'M11 12a5.006 5.006 0 0 1 4.995 4.783L16 17v2H4v-2c0-2.757 2.243-5 5-5h2zm0 2H9c-1.654 0-3 1.346-3 3h8a3.004 3.004 0 0 0-2.824-2.995L11 14zM5.357 9.041l.075-.008c.35.784.896 1.46 1.575 1.969L6 11c-1.654 0-3 1.346-3 3h.805a5.958 5.958 0 0 0-.722 2H1v-2a5.008 5.008 0 0 1 4.357-4.959l.075-.008zm9.211-.008a5.006 5.006 0 0 1 4.427 4.75L19 14v2h-2.085a5.994 5.994 0 0 0-.724-2H17a3.004 3.004 0 0 0-2.824-2.995L14 11l-1.004.001a5.028 5.028 0 0 0 1.572-1.968zM10 3c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4zm0 2c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zm3.5-4C15.43 1 17 2.57 17 4.5c0 1.412-.84 2.632-2.048 3.184a4.982 4.982 0 0 0-.227-2.32 1.502 1.502 0 0 0-1.648-2.303 4.986 4.986 0 0 0-2.114-.968A3.483 3.483 0 0 1 13.5 1zm-7 0c.998 0 1.9.42 2.538 1.092a4.986 4.986 0 0 0-2.116.97 1.502 1.502 0 0 0-1.648 2.303 4.984 4.984 0 0 0-.227 2.319A3.505 3.505 0 0 1 3 4.5C3 2.57 4.57 1 6.5 1z',
    size: 20,
  },
  '20-users-interactions': {
    path:
      'M9.857 1A3.143 3.143 0 0 1 13 4.143V8h3a3 3 0 0 1 2.828 4.002l-1.771 5A3 3 0 0 1 14.229 19H4a3 3 0 0 1-3-3v-5a3 3 0 0 1 3-3h1.215l1.018-4.157A3.731 3.731 0 0 1 9.857 1zM5 10H4a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h1v-7zm4.857-7c-.797 0-1.491.545-1.681 1.32L7 9.117V17h7.39a1 1 0 0 0 .942-.666l1.77-5A1 1 0 0 0 16.16 10H13a2 2 0 0 1-2-2V4.143C11 3.512 10.488 3 9.857 3z',
    size: 20,
  },
  '20-upload': {
    path:
      'M17 12a1 1 0 0 1 .993.883L18 13v3a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-3l.007-.117a1 1 0 0 1 1.986 0L2 13v3h14v-3l.007-.117a1 1 0 0 1 .876-.876L17 12zM8.293.707a1 1 0 0 1 1.32-.083l.094.083 3.585 3.585c.362.362.39.93.086 1.323l-.083.095a.998.998 0 0 1-1.319.085l-.094-.083L10 3.83V13a1 1 0 0 1-1.993.117L8 13V3.83L6.116 5.706A.999.999 0 0 1 4.622 4.39l.083-.094L8.293.707z',
    size: 20,
  },
  '20-video': {
    path:
      'M10 1a9 9 0 1 1 0 18 9 9 0 0 1 0-18zm0 2a7 7 0 1 0 0 14 7 7 0 0 0 0-14zM8 5.5l6 4.5-6 4.5v-9z',
    size: 20,
  },
  '20-video-frame': {
    path:
      'M18 1c.552 0 1 .448 1 1v16c0 .552-.448 1-1 1H2c-.552 0-1-.448-1-1V2c0-.552.448-1 1-1zm-5 10H7v6h6v-6zM5 3H3v2h2v2H3v2h2v2H3v2h2v2H3v2h2V3zm10 14h2v-2h-2v2zm0-4h2v-2h-2v2zm0-4h2V7h-2v2zM7 3v6h6V3H7zm8 2h2V3h-2v2z',
    size: 20,
  },
  '20-view-horizontal': {
    path:
      'M17 5a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h14zm0 2H3v6h14V7zm1-6a1 1 0 0 1 0 2H2a1 1 0 1 1 0-2zM2 19h16a1 1 0 0 0 0-2H2a1 1 0 0 0 0 2z',
    size: 20,
  },
  '20-view-list': {
    path:
      'M17 11a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h14zm0 2H3v4h14v-4zm0-12a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14zm0 2H3v4h14V3z',
    size: 20,
  },
  '20-view-masonry': {
    path:
      'M3,11 L3,9 L6,9 L6,3 L8,3 L8,9 L17,9 L17,11 L14,11 L14,17 L12,17 L12,11 L3,11 Z M17,1 C18.1045695,1 19,1.8954305 19,3 L19,17 C19,18.1045695 18.1045695,19 17,19 L3,19 C1.8954305,19 1,18.1045695 1,17 L1,3 C1,1.8954305 1.8954305,1 3,1 L17,1 Z M3,3 L3,17 L17,17 L17,3 L3,3 Z',
    size: 20,
  },
  '20-view-mosaic': {
    path:
      'M7 11c1.103 0 2 .897 2 2v4c0 1.103-.897 2-2 2H3c-1.103 0-2-.897-2-2v-4c0-1.103.897-2 2-2h4zm10 0c1.103 0 2 .897 2 2v4c0 1.103-.897 2-2 2h-4c-1.103 0-2-.897-2-2v-4c0-1.103.897-2 2-2h4zM7 13H3v4h3.997L7 13zm10 0h-4v4h3.997L17 13zM7 1c1.103 0 2 .897 2 2v4c0 1.103-.897 2-2 2H3c-1.103 0-2-.897-2-2V3c0-1.103.897-2 2-2h4zm10 0c1.103 0 2 .897 2 2v4c0 1.103-.897 2-2 2h-4c-1.103 0-2-.897-2-2V3c0-1.103.897-2 2-2h4zM7 3H3v4h3.997L7 3zm10 0h-4v4h3.997L17 3z',
    size: 20,
  },
  '20-view-vertical': {
    path:
      'M2 1a1 1 0 0 1 1 1v16a1 1 0 0 1-2 0V2a1 1 0 0 1 1-1zm16 0a1 1 0 0 1 1 1v16a1 1 0 0 1-2 0V2a1 1 0 0 1 1-1zm-5 0a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h6zm0 2H7v14h6V3z',
    size: 20,
  },
  '20-wallet': {
    path:
      'M16 1a2 2 0 0 1 2 2l.001 2.268A2 2 0 0 1 19 7v6a2 2 0 0 1-.999 1.732L18 17a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h13zm0 2H3v14h13v-2h-6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h6V3zm1 4h-7v6h7V7zm-4 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2z',
    size: 20,
  },
  '20-warning': {
    path:
      'M11.76 1.995l.077.14 6.946 13.893a2.054 2.054 0 0 1-1.684 2.966l-.153.006H3.054a2.054 2.054 0 0 1-1.903-2.826l.066-.146L8.163 2.136a2.054 2.054 0 0 1 3.597-.141zM10 3L3 17h14L10 3zm0 10a1 1 0 0 1 1 1v1a1 1 0 1 1-2 0v-1a1 1 0 0 1 1-1zm0-6a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0V8a1 1 0 0 1 1-1z',
    size: 20,
  },
  '20-warning-solid': {
    path:
      'M11.76 1.995l.077.14 6.946 13.893a2.054 2.054 0 0 1-1.684 2.966l-.153.006H3.054a2.054 2.054 0 0 1-1.903-2.826l.066-.146L8.163 2.136a2.054 2.054 0 0 1 3.597-.141zM10 13a1 1 0 0 0-1 1v1a1 1 0 1 0 2 0v-1a1 1 0 0 0-1-1zm0-6a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0V8a1 1 0 0 0-1-1z',
    size: 20,
  },
  '20-windows': {
    path:
      'M17.876 1.008A1 1 0 0119 2v16a1 1 0 01-1.124.992l-16-2A1 1 0 011 16V4a1 1 0 01.876-.992zM17 11H9.999v4.992l7.001.875V11zm-9.001 0H3v4.117l4.999.625V11zm0-6.742L3 4.883V9h4.999V4.258zM17 3.133l-7.001.875V9H17V3.133z',
    size: 20,
  },
  '20-wp-kreator': {
    path:
      'M12.5674 3.82843L13.5948 4.8558H13.21C12.8551 4.8558 12.5674 4.56808 12.5674 4.21317V3.82843ZM11.2821 3V4.21317C11.2821 5.27792 12.1453 6.14107 13.21 6.14107H14.4232H16.4232V4.8558L12.5674 1H11.2821H2.28527C1.57543 1 1 1.57543 1 2.28527V17.7085C1 18.4183 1.57543 18.9937 2.28527 18.9937H6.14107V16.9937H3V3H11.2821ZM14.0038 9.79073L16.6348 12.4224L10.0573 19H7.42633V16.369L14.0038 9.79073ZM14.0038 11.6515L8.74183 16.9136V17.6845H9.51272L14.7747 12.4224L14.0038 11.6515ZM16.1806 7.61443C16.4317 7.3636 16.8385 7.36364 17.0895 7.6145L18.8117 9.33671L18.8653 9.39726C19.0613 9.64939 19.0434 10.0139 18.8116 10.2455L17.2955 11.7611L14.6651 9.12942L16.1806 7.61443ZM4.21317 4.8558C3.85825 4.8558 3.57053 5.14352 3.57053 5.49843C3.57053 5.85335 3.85825 6.14107 4.21317 6.14107H8.7116C9.06651 6.14107 9.35423 5.85335 9.35423 5.49843C9.35423 5.14352 9.06651 4.8558 8.7116 4.8558H4.21317ZM3.57053 8.06897C3.57053 7.71405 3.85825 7.42633 4.21317 7.42633H6.7837C7.13861 7.42633 7.42633 7.71405 7.42633 8.06897C7.42633 8.42388 7.13862 8.7116 6.7837 8.7116H4.21317C3.85825 8.7116 3.57053 8.42388 3.57053 8.06897ZM4.21317 9.99687C3.85825 9.99687 3.57053 10.2846 3.57053 10.6395C3.57053 10.9944 3.85825 11.2821 4.21317 11.2821H9.99687C10.3518 11.2821 10.6395 10.9944 10.6395 10.6395C10.6395 10.2846 10.3518 9.99687 9.99687 9.99687H4.21317Z',
    size: 20,
  },
  '20-wp-solid': {
    path:
      'M16 0a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h12zM4.449 6.021c-.388-.059-.752.002-1.08.222a.799.799 0 0 0-.335.43.737.737 0 0 0-.009.413c.051.193.112.385.171.576.072.228.148.454.22.682.085.267.167.534.25.8l.22.7.217.69.18.58.203.647c.057.182.116.364.172.547.068.227.14.453.24.67.114.242.274.45.49.615.323.246.695.363 1.098.398a3 3 0 0 0 .663-.023c.38-.05.74-.157 1.07-.355.318-.192.573-.442.738-.774.115-.231.172-.477.2-.73.031-.267.056-.534.083-.8l.11-1.063.085-.866.102-.992c.005-.053.01-.106.018-.158.008-.056.036-.085.083-.09.053-.005.086.017.106.071a.326.326 0 0 1 .012.042l.094.409.276 1.203c.084.363.167.727.252 1.09.085.363.17.726.26 1.088.044.18.112.35.22.504.23.33.551.505.958.53a1.77 1.77 0 0 0 .607-.067c.267-.078.507-.202.708-.392.24-.228.38-.507.448-.824.037-.174.05-.352.07-.529l.119-1.095.097-.92.066-.624.046-.412h.066l1.087.017c.09.002.181.001.27.011.67.05.573 1.446.066 1.528a3.445 3.445 0 0 1-.296.031c-.169.012-.337.02-.506.031a.377.377 0 0 0-.276.143.856.856 0 0 0-.1.146.85.85 0 0 0-.064.621.582.582 0 0 0 .134.258c.075.08.167.116.278.104l.156-.018c.204-.025.407-.048.61-.074.13-.017.26-.035.386-.075.5-.157.855-.465 1.042-.952.101-.266.149-.54.163-.821a3.144 3.144 0 0 0-.021-.648 2.46 2.46 0 0 0-.142-.547c-.24-.582-.675-.94-1.305-1.066-.11-.022-.224-.028-.336-.039-.177-.016-.355-.03-.533-.044l-.51-.04-.4-.03c-.128-.011-.258-.02-.386-.033-.272-.029-.596.104-.714.425a1.173 1.173 0 0 0-.062.295l-.078.784c-.028.278-.058.555-.085.833a58.693 58.693 0 0 0-.137 1.569l-.063.834c-.004.05-.009.099-.016.148-.006.042-.026.064-.055.068a.09.09 0 0 1-.102-.066c-.01-.04-.017-.08-.025-.119-.117-.581-.233-1.163-.351-1.744l-.325-1.593a2.633 2.633 0 0 0-.229-.689 1.685 1.685 0 0 0-.763-.77 2.187 2.187 0 0 0-1.55-.148 1.341 1.341 0 0 0-.708.448c-.133.16-.225.342-.289.538-.071.22-.1.448-.122.676l-.084.9-.108 1.156-.086.916-.072.751c-.01.09-.016.18-.026.269-.007.063-.034.09-.094.098-.073.012-.122-.02-.142-.093-.02-.076-.036-.154-.054-.23-.058-.251-.116-.502-.176-.752-.062-.255-.127-.51-.192-.765-.09-.352-.179-.705-.27-1.057-.076-.288-.154-.576-.232-.863l-.23-.851c-.055-.2-.11-.401-.163-.602a1.24 1.24 0 0 0-.423-.667 1.812 1.812 0 0 0-.885-.395',
    size: 20,
    fill: '#262628',
  },
  '20-wp-holding': {
    path:
      'M15.55,7.43c-.12,0-.16,0-.17.16-.08.85-.17,1.69-.26,2.54s-.14,1.63-.27,2.44a2.22,2.22,0,0,1-2.78,1.81,1.75,1.75,0,0,1-1.22-1.44q-.6-2.7-1.18-5.42v0c0-.08-.05-.19-.15-.16a.28.28,0,0,0-.13.17c-.06.5-.11,1-.15,1.49l-.33,3.42c0,.34-.06.68-.12,1a2.56,2.56,0,0,1-1.51,1.94,3.69,3.69,0,0,1-2.55.29,2.38,2.38,0,0,1-1.8-1.75c-.32-1-.62-2.07-.92-3.1-.45-1.51-.9-3-1.34-4.53-.05-.17-.1-.34-.14-.52A1.09,1.09,0,0,1,.88,4.67,2.16,2.16,0,0,1,4.22,5.73c.33,1.29.66,2.58,1,3.87.28,1.13.53,2.27.8,3.41l0,.15c0,.1.09.18.19.14a.24.24,0,0,0,.14-.17c0-.21.05-.42.07-.64.14-1.61.27-3.22.42-4.83a6.74,6.74,0,0,1,.21-1.27A1.88,1.88,0,0,1,8.68,5a2.63,2.63,0,0,1,2.3.66,3,3,0,0,1,.83,1.72c.31,1.62.62,3.25.92,4.87v0c0,.09,0,.2.15.18s.1-.12.11-.19c0-.3,0-.6.07-.9.09-1.15.19-2.3.28-3.45.05-.57.1-1.14.17-1.71a.93.93,0,0,1,1.09-.89l2.62.23a2.38,2.38,0,0,1,2.14,1.91,4.6,4.6,0,0,1-.07,2.44,2.14,2.14,0,0,1-1.83,1.59c-.38.06-.77.09-1.15.15a.44.44,0,0,1-.46-.23A1.22,1.22,0,0,1,16,9.9a.66.66,0,0,1,.36-.13,9.06,9.06,0,0,1,.91-.07.54.54,0,0,0,.5-.35,1.8,1.8,0,0,0,.08-1.42.64.64,0,0,0-.63-.47h-.84Z',
    size: 20,
  },
  '20-wppilot': {
    path:
      'M9 15H3a2 2 0 01-2-2V3a2 2 0 012-2h14a2 2 0 012 2v10a2 2 0 01-2 2h-6v2h4a1 1 0 010 2H5a1 1 0 010-2h4v-2zm8-12H3v10h14V3zM8 5l5 3-5 3V5z',
    size: 20,
  },
  '20-wp-specials': {
    path:
      'M17,1 L17.1492623,1.00548574 C18.1841222,1.08183488 19,1.9456382 19,3 L19,3 L19,15 L18.9951047,15.1996403 C18.8910789,17.3160315 17.1421954,19 15,19 L15,19 L5,19 L4.7950809,18.9954811 C2.62590212,18.89936 1,17.2788336 1,15 L1,15 L1,8 L1.00548574,7.85073766 C1.08183488,6.81587779 1.9456382,6 3,6 L3,6 L4,5.999 L4,5 L4.00548574,4.85073766 C4.08183488,3.81587779 4.9456382,3 6,3 L6,3 L7,3 L7.00548574,2.85073766 C7.08183488,1.81587779 7.9456382,1 9,1 L9,1 L17,1 Z M17,3 L9,3 L9,15 L8.99262174,15.2639857 C8.95834043,15.8726799 8.80565551,16.4296243 8.5567006,16.9171118 L8.5567006,16.9171118 L8.511,16.999 L15,17 L15.1492623,16.9945143 C16.1841222,16.9181651 17,16.0543618 17,15 L17,15 L17,3 Z M7,4.999 L6,5 L6,15 C6,15.5522847 5.55228475,16 5,16 C4.48716416,16 4.06449284,15.6139598 4.00672773,15.1166211 L4,15 L4,8 L3,8 L3,15 C3,16.223971 3.81325872,17 5,17 L5,17 L5.15947208,16.9952207 C6.25899361,16.9285264 7,16.168336 7,15 L7,15 L7,4.999 Z M14,13 C14.5522847,13 15,13.4477153 15,14 C15,14.5128358 14.6139598,14.9355072 14.1166211,14.9932723 L14,15 L12,15 C11.4477153,15 11,14.5522847 11,14 C11,13.4871642 11.3860402,13.0644928 11.8833789,13.0067277 L12,13 L14,13 Z M14,9 C14.5522847,9 15,9.44771525 15,10 C15,10.5128358 14.6139598,10.9355072 14.1166211,10.9932723 L14,11 L12,11 C11.4477153,11 11,10.5522847 11,10 C11,9.48716416 11.3860402,9.06449284 11.8833789,9.00672773 L12,9 L14,9 Z M14,5 C14.5522847,5 15,5.44771525 15,6 C15,6.51283584 14.6139598,6.93550716 14.1166211,6.99327227 L14,7 L12,7 C11.4477153,7 11,6.55228475 11,6 C11,5.48716416 11.3860402,5.06449284 11.8833789,5.00672773 L12,5 L14,5 Z',
    size: 20,
  },
  '20-wp-magazine': {
    path:
      'M14.9230769,1 C15.2703376,1 15.5927368,1.1801551 15.7747352,1.47590257 L15.7747352,1.47590257 L18.8516583,6.47590257 C19.0640851,6.82109611 19.0471334,7.26037537 18.8087361,7.5881717 L18.8087361,7.5881717 L10.8087361,18.5881717 C10.4093874,19.1372761 9.59061257,19.1372761 9.19126392,18.5881717 L9.19126392,18.5881717 L1.19126392,7.5881717 C0.952866588,7.26037537 0.935914893,6.82109611 1.14834168,6.47590257 L1.14834168,6.47590257 L4.22526476,1.47590257 C4.40726321,1.1801551 4.72966237,1 5.07692308,1 L5.07692308,1 Z M11.6899986,8 L8.30899856,8 L9.99899856,14.2 L11.6899986,8 Z M16.0349986,8 L13.7629986,8 L12.3999986,12.999 L16.0349986,8 Z M6.23599856,8 L3.96399856,8 L7.59899856,12.998 L6.23599856,8 Z M6.77999856,3 L5.635,3 L3.78799856,6 L6.17999856,6 L6.77999856,3 Z M11.1799986,3 L8.81899856,3 L8.21899856,6 L11.7799986,6 L11.1799986,3 Z M14.364,3 L13.2189986,3 L13.8189986,6 L16.2109986,6 L14.364,3 Z',
    size: 20,
  },
  '20-wp-be-healthy-magazine': {
    path:
      'M13.042 4.01933C12.3852 4.1139 11.5721 4.5932 10.8789 5.87022C10.704 6.19247 10.3667 6.39314 10 6.39314C9.63336 6.39315 9.29609 6.19248 9.12116 5.87023C8.42796 4.59325 7.6148 4.11394 6.95799 4.01936C6.29392 3.92373 5.55856 4.18623 4.93838 4.85978C4.39912 5.4514 4.08086 6.24113 4.01344 7.0801C3.9692 7.63061 3.48706 8.04103 2.93655 7.99679C2.38604 7.95255 1.97563 7.47041 2.01987 6.9199C2.11866 5.6905 2.58953 4.46663 3.46238 3.51018L3.46499 3.50731L3.465 3.50732C4.44589 2.44081 5.80878 1.83323 7.24306 2.03978C8.26735 2.18728 9.21276 2.73239 10 3.63541C10.7873 2.73236 11.7327 2.18724 12.757 2.03975C14.1913 1.83322 15.5542 2.44082 16.535 3.50732L16.5377 3.51017L16.5377 3.51018C17.4105 4.46663 17.8814 5.6905 17.9802 6.9199C18.0244 7.47041 17.614 7.95255 17.0635 7.99679C16.513 8.04103 16.0308 7.63061 15.9866 7.0801C15.9192 6.24116 15.6009 5.45145 15.0617 4.85984C14.4415 4.18623 13.7061 3.9237 13.042 4.01933ZM7.29289 14.2929C7.68342 13.9024 8.31658 13.9024 8.70711 14.2929L10 15.5858L11.2929 14.2929C11.6834 13.9024 12.3166 13.9024 12.7071 14.2929C13.0976 14.6834 13.0976 15.3166 12.7071 15.7071L10.7071 17.7071C10.3166 18.0976 9.68342 18.0976 9.29289 17.7071L7.29289 15.7071C6.90237 15.3166 6.90237 14.6834 7.29289 14.2929ZM8.26822 8.35982C8.07248 8.12493 7.78004 7.9925 7.47438 8.00033C7.16873 8.00816 6.88345 8.1554 6.7 8.4L5.5 10H3C2.44772 10 2 10.4477 2 11C2 11.5523 2.44772 12 3 12H6C6.31476 12 6.61115 11.8518 6.8 11.6L7.5413 10.6116L9.23178 12.6402C9.42177 12.8682 9.70322 13 10 13C10.2968 13 10.5782 12.8682 10.7682 12.6402L12.4587 10.6116L13.2 11.6C13.3889 11.8518 13.6852 12 14 12H17C17.5523 12 18 11.5523 18 11C18 10.4477 17.5523 10 17 10H14.5L13.3 8.4C13.1165 8.1554 12.8313 8.00816 12.5256 8.00033C12.22 7.9925 11.9275 8.12493 11.7318 8.35982L10 10.438L8.26822 8.35982Z',
    size: 20,
  },
  '20-zoom-in': {
    path:
      'M8 5c.552 0 1 .448 1 1v1h1c.552 0 1 .448 1 1s-.448 1-1 1H9v1c0 .552-.448 1-1 1s-1-.448-1-1V9H6c-.552 0-1-.448-1-1s.448-1 1-1h1V6c0-.552.448-1 1-1zM3 8c0-2.757 2.243-5 5-5s5 2.243 5 5-2.243 5-5 5-5-2.243-5-5m15.707 9.293l-5.106-5.106C14.476 11.018 15 9.572 15 8c0-3.866-3.134-7-7-7S1 4.134 1 8s3.134 7 7 7c1.572 0 3.018-.524 4.187-1.399l5.106 5.106c.195.195.451.293.707.293.256 0 .512-.098.707-.293.391-.391.391-1.023 0-1.414',
    size: 20,
  },
  '20-zoom-out': {
    path:
      'M11 8c0 .552-.448 1-1 1H6c-.552 0-1-.448-1-1s.448-1 1-1h4c.552 0 1 .448 1 1zM3 8c0-2.757 2.243-5 5-5s5 2.243 5 5-2.243 5-5 5-5-2.243-5-5m15.707 9.293l-5.106-5.106C14.476 11.018 15 9.572 15 8c0-3.866-3.134-7-7-7S1 4.134 1 8s3.134 7 7 7c1.572 0 3.018-.524 4.187-1.399l5.106 5.106c.195.195.451.293.707.293.256 0 .512-.098.707-.293.391-.391.391-1.023 0-1.414',
    size: 20,
  },
  '20-reverse': {
    paths: [
      {
        path:
          'M11 1L11 14.9358L14.2901 11.1429C14.6806 10.7524 15.3196 10.7524 15.7101 11.1429C16.1006 11.5334 16.1005 12.1666 15.71 12.5571L11.1339 17.6303C10.3464 18.4178 9 17.8601 9 16.7464L9 1C9 0.447715 9.44772 0 10 0C10.5523 0 11 0.447715 11 1Z',
      },
      {
        path:
          'M5.00293 16.9989V3.06317L1.71286 6.85606C1.32233 7.24658 0.68338 7.24658 0.292856 6.85606C-0.0976685 6.46553 -0.0975937 5.83237 0.292931 5.44184L4.86905 0.368622C5.6565 -0.418831 7.00293 0.13887 7.00293 1.25251V16.9989C7.00293 17.5512 6.55522 17.9989 6.00293 17.9989C5.45065 17.9989 5.00293 17.5512 5.00293 16.9989Z',
      },
    ],
    size: 20,
  },
}

export const smallIcons: IIcons = {
  '16-alert-solid': {
    path:
      'M8 14A6 6 0 1 1 8 2a6 6 0 0 1 0 12zm0-5a1 1 0 0 0 1-1V5a1 1 0 0 0-2 0v3a1 1 0 0 0 1 1zm0 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2z',
    size: 16,
  },
  '16-alternatives': {
    path:
      'M12 3c1.105 0 2 .895 2 2s-.895 2-2 2c-.74 0-1.387-.402-1.732-1H8.414l-2 2 2 2h1.854c.345-.598.992-1 1.732-1 1.105 0 2 .895 2 2s-.895 2-2 2c-.74 0-1.387-.402-1.732-1H8c-.265 0-.52-.105-.707-.293L4.586 9H3c-.552 0-1-.448-1-1s.448-1 1-1h1.586l2.707-2.707C7.48 4.105 7.735 4 8 4l2.268-.001C10.614 3.402 11.26 3 12 3z',
    size: 16,
  },
  '16-arrow-down': {
    path:
      'M7.883 13.993a.506.506 0 01-.06-.009l-.06-.012c-.02-.005-.04-.01-.059-.017a.566.566 0 01-.058-.02l-.05-.02-.062-.03-.024-.013-.019-.011-.071-.046-.02-.015-4-3a1 1 0 011.095-1.669L4.6 9.2 7 11V3a1 1 0 011.993-.117L9 3v8l2.4-1.8a1 1 0 011.296 1.519l-.096.081-4 3-.028.02a.657.657 0 01-.062.04l.09-.06c-.043.032-.088.06-.134.085l-.062.03-.05.02a.802.802 0 01-.058.02l-.06.017a.541.541 0 01-.058.012l-.059.009h-.002L8 14l-.117-.007z',
    size: 16,
  },
  '16-arrow-left': {
    path:
      'M2.007 7.883a.506.506 0 01.009-.06l.012-.06c.005-.02.01-.04.017-.059a.566.566 0 01.02-.058l.02-.05.03-.062.013-.024.011-.019.046-.071.015-.02 3-4a1 1 0 011.669 1.095L6.8 4.6 5 7h8a1 1 0 01.117 1.993L13 9H5l1.8 2.4a1 1 0 01-1.519 1.296L5.2 12.6l-3-4-.02-.028a.657.657 0 01-.04-.062l.06.09a1.118 1.118 0 01-.085-.134l-.03-.062-.02-.05c-.008-.02-.014-.039-.02-.058l-.017-.06a.541.541 0 01-.012-.058l-.009-.059v-.002L2 8l.007-.117z',
    size: 16,
  },
  '16-arrow-right': {
    path:
      'M13.993 8.117a.506.506 0 01-.009.06l-.012.06c-.005.02-.01.04-.017.059a.566.566 0 01-.02.058l-.02.05-.03.062-.013.024-.011.019-.046.071-.015.02-3 4a1 1 0 01-1.669-1.095L9.2 11.4 11 9H3a1 1 0 01-.117-1.993L3 7h8L9.2 4.6a1 1 0 011.519-1.296l.081.096 3 4 .02.028c.014.02.028.04.04.062l-.06-.09c.032.043.06.088.085.134l.03.062.02.05c.008.02.014.039.02.058l.017.06a.541.541 0 01.012.058l.009.059v.002L14 8l-.007.117z',
    size: 16,
  },
  '16-arrow-up': {
    path:
      'M8.117 2.007a.506.506 0 01.06.009l.06.012c.02.005.04.01.059.017.02.006.039.012.058.02l.05.02.062.03.024.013.019.011.071.046.02.015 4 3a1 1 0 01-1.095 1.669L11.4 6.8 9 5v8a1 1 0 01-1.993.117L7 13V5L4.6 6.8a1 1 0 01-1.296-1.519L3.4 5.2l4-3 .028-.02c.02-.014.04-.028.062-.04l-.09.06c.043-.032.088-.06.134-.085l.062-.03.05-.02c.02-.008.039-.014.058-.02l.06-.017a.541.541 0 01.058-.012l.059-.009h.002L8 2l.117.007z',
    size: 16,
  },
  '16-arrowhead-down': {
    path: 'M8 11l4-6H4z',
    size: 16,
  },
  '16-arrowhead-left': {
    path: 'M5 8l6-4v8z',
    size: 16,
  },
  '16-arrowhead-right': {
    path: 'M11 8l-6 4V4z',
    size: 16,
  },
  '16-arrowhead-up': {
    path: 'M8 5l4 6H4z',
    size: 16,
  },
  '16-calendar': {
    path:
      'M6 2C5.44772 2 5 2.44772 5 3V4H4C2.89543 4 2 4.89543 2 6V12C2 13.1046 2.89543 14 4 14H12C13.1046 14 14 13.1046 14 12V6C14 4.89543 13.1046 4 12 4H11V3C11 2.44772 10.5523 2 10 2C9.44772 2 9 2.44772 9 3V4H7V3C7 2.44772 6.55228 2 6 2ZM12 6H4V8H12V6Z',
    size: 16,
  },
  '16-check': {
    path:
      'M7 12a.993.993 0 0 1-.707-.293l-3-3a.999.999 0 1 1 1.414-1.414L6.933 9.52l4.298-5.16a1.004 1.004 0 0 1 1.41-.128c.423.354.481.985.128 1.41l-5 6a1.007 1.007 0 0 1-.724.358L7 12',
    size: 16,
  },
  '16-close': {
    path:
      'M9.414 8l3.293-3.293a.999.999 0 1 0-1.414-1.414L8 6.586 4.707 3.293a.999.999 0 1 0-1.414 1.414L6.586 8l-3.293 3.293a.999.999 0 1 0 1.414 1.414L8 9.414l3.293 3.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L9.414 8z',
    size: 16,
  },
  '16-commercial': {
    path:
      'M8,2 C11.3137085,2 14,4.6862915 14,8 C14,11.3137085 11.3137085,14 8,14 C4.6862915,14 2,11.3137085 2,8 C2,4.6862915 4.6862915,2 8,2 Z M9,4 L7,4 L7,5.10898459 L7,5.10898459 C6.43656936,5.12075127 5.95961,5.4825704 5.62081283,5.84315789 C5.1364134,6.40292984 5.13296293,7.12810196 5.61202276,7.69053503 C6.14925951,8.34343789 7.0713843,8.53679503 7.88511073,8.70727503 C8.73582371,8.88556075 9.15112074,9.00275503 9.28258178,9.30409503 C9.40929153,9.59818075 9.00425833,9.81386075 8.77390901,9.88640646 C8.29983277,10.0215209 7.77446024,10.0062451 7.31527872,9.84399503 C6.92497546,9.72358597 6.61522001,9.48798251 6.45652193,9.19081503 C6.3175729,8.89356118 5.88865438,8.73840994 5.49850561,8.84427503 C5.10835684,8.95014013 4.90471923,9.27693261 5.04366826,9.57418646 C5.33587269,10.1679445 5.93697217,10.6433889 6.70480765,10.8880779 C6.80317346,10.9207637 6.99932143,10.9743612 7.00512717,10.9758329 C7.00899767,10.976814 7.00899767,11.3175418 7.00512717,11.9980164 L9,11.9980164 C9,11.3548166 9.0031762,11.0325365 9.0095286,11.0311761 C9.01905721,11.0291354 9.23603313,10.9773046 9.34594228,10.9430465 C10.4790062,10.5859036 11.051767,9.74689789 10.7067943,8.94583789 C10.3068874,8.02955218 9.18481101,7.79433218 8.28319138,7.60543503 C7.67967286,7.47904075 7.10984085,7.35934075 6.88205655,7.08227789 C6.72280501,6.90297359 6.71522349,6.66942107 6.8626464,6.48433789 C7.14866116,6.16179218 7.88291321,6.09873503 8.44286014,6.1760236 C8.93601371,6.25170851 9.34536034,6.51244871 9.53051499,6.8688236 C9.64732566,7.17132447 10.0637039,7.34453369 10.4608551,7.25583584 C10.8580063,7.16713799 11.085758,6.85007183 10.9697351,6.54739503 C10.6638999,5.85389175 9.90784887,5.31571665 9,5.10633789 C9.00011081,5.10636345 9.00011081,4.73758415 9,4 Z',
    size: 16,
  },
  '16-comment': {
    path:
      'M14 3.3466C14 2.60289 13.403 2 12.6667 2H3.33333C2.59695 2 2 2.60289 2 3.3466V12.9881C2 13.8402 2.98031 14.3093 3.63324 13.7698L5.66667 12.0895H12.6667C13.403 12.0895 14 11.4866 14 10.7429V3.3466Z',
    size: 16,
  },
  '16-copy': {
    path:
      'M12,5 C13.103,5 14,5.897 14,7 L14,7 L14,12 C14,13.103 13.103,14 12,14 L12,14 L7,14 C5.897,14 5,13.103 5,12 L5,12 L5,7 C5,5.897 5.897,5 7,5 L7,5 Z M12.003,7 L7,7 L7,12 L12,12 L12.003,7 Z M9,2 C10.103,2 11,2.897 11,4 L11,4 L4,4 L4,11 C2.897,11 2,10.103 2,9 L2,9 L2,4 C2,2.897 2.897,2 4,2 L4,2 Z',
    size: 16,
  },
  '16-crop': {
    path:
      'M5 2c.513 0 .936.386.993.883L6 3v.999L11 4c.513 0 .936.386.993.883L12 5v5h1c.513 0 .936.386.993.883L14 11c0 .513-.386.936-.883.993L13 12h-1v1c0 .552-.448 1-1 1-.513 0-.936-.386-.993-.883L10 13v-1H5c-.513 0-.936-.386-.993-.883L4 11V5.999L3 6c-.513 0-.936-.386-.993-.883L2 5c0-.513.386-.936.883-.993L3 4l1-.001V3c0-.552.448-1 1-1zm1 8h4V6l-4-.001V10z',
    size: 16,
  },
  '16-divide': {
    path:
      'M8 2C7.44772 2 7 2.44772 7 3V13C7 13.5523 7.44772 14 8 14C8.55228 14 9 13.5523 9 13V3C9 2.44772 8.55228 2 8 2ZM2 7.5C2 6.67157 2.67157 6 3.5 6C4.32843 6 5 6.67157 5 7.5V8.5C5 9.32843 4.32843 10 3.5 10C2.67157 10 2 9.32843 2 8.5V7.5ZM11 7.5C11 6.67157 11.6716 6 12.5 6C13.3284 6 14 6.67157 14 7.5V8.5C14 9.32843 13.3284 10 12.5 10C11.6716 10 11 9.32843 11 8.5V7.5Z',
    size: 16,
  },
  '16-delete': {
    path:
      'M12 6v6c0 1.105-.895 2-2 2H6c-1.105 0-2-.895-2-2V6h8zM9.5 2l1 1H12c.552 0 1 .448 1 1s-.448 1-1 1H4c-.552 0-1-.448-1-1s.448-1 1-1h1.5l1-1h3z',
    size: 16,
  },
  '16-desktop': {
    path:
      'M7 10H3C2.44772 10 2 9.55228 2 9V3C2 2.44772 2.44772 2 3 2H13C13.5523 2 14 2.44772 14 3V9C14 9.55228 13.5523 10 13 10H9V12H11C11.5523 12 12 12.4477 12 13C12 13.5523 11.5523 14 11 14H5C4.44772 14 4 13.5523 4 13C4 12.4477 4.44772 12 5 12H7V10Z',
    size: 16,
  },
  '16-drag-and-drop': {
    path:
      'M10 11c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm-4 0c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm4-4c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zM6 7c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zm4-4c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1zM6 3c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z',
    size: 16,
  },
  '16-edit': {
    path:
      'M12.468 2.169A.571.571 0 0 0 12.055 2a.572.572 0 0 0-.408.169L10 3.817 12.183 6l1.647-1.648a.58.58 0 0 0 0-.82l-1.362-1.363zM2 11.629V14h2.372L11 7.372 8.628 5 2 11.628z',
    size: 16,
  },
  '16-edit-crossed': {
    path:
      'M0 9.62808L3.44036 6.26879L5.73104 8.55946L2.37192 12H0V9.62808ZM6.30251 3.47408L8.5256 5.69717L10.1826 4L11.8298 2.35226C12.0567 2.12518 12.0567 1.75837 11.8298 1.5313L10.4678 0.16885C10.3514 0.0524019 10.2059 0 10.0546 0C9.90324 0 9.75773 0.0582243 9.64714 0.16885L8 1.81659L6.30251 3.47408ZM0.292893 1.70711C-0.0976315 1.31658 -0.0976315 0.683418 0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L11.7071 10.2929C12.0976 10.6834 12.0976 11.3166 11.7071 11.7071C11.3166 12.0976 10.6834 12.0976 10.2929 11.7071L0.292893 1.70711Z',
    size: 16,
  },
  '16-eye': {
    path:
      'M8 4c1.835 0 3.67 1.122 5.505 3.367.3.368.3.898 0 1.266l-.23.275C11.517 10.969 9.758 12 8 12c-1.835 0-3.67-1.122-5.505-3.367-.3-.368-.3-.898 0-1.266l.23-.275C4.483 5.031 6.242 4 8 4zm0 2c-1.105 0-2 .895-2 2s.895 2 2 2 2-.895 2-2-.895-2-2-2z',
    size: 16,
  },
  '16-eye-crossed': {
    path:
      'M13.707 2.293c.36.36.388.928.083 1.32l-.083.094-1.903 1.901C12.536 6.227 13.268 7.024 14 8c-2 2.667-4 4-6 4-.698 0-1.397-.163-2.095-.488l-2.198 2.195c-.39.39-1.024.39-1.414 0-.36-.36-.388-.928-.083-1.32l.083-.094 10-10c.39-.39 1.024-.39 1.414 0zm-3.774 5.19l-2.45 2.45c.165.044.338.067.517.067 1.105 0 2-.895 2-2 0-.179-.023-.352-.067-.517zM8 4c.184 0 .368.011.552.034L3.174 9.412C2.783 8.992 2.391 8.522 2 8c2-2.667 4-4 6-4z',
    size: 16,
  },
  '16-info-solid': {
    path:
      'M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2zm0 5a1 1 0 0 1 1 1v3a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1zm0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2z',
    size: 16,
  },
  '16-label': {
    path:
      'M13 2c.552 0 1 .448 1 1v3.586c0 .265-.105.52-.293.707l-6 6c-.39.39-1.024.39-1.414 0L2.707 9.707c-.39-.39-.39-1.024 0-1.414l6-6C8.895 2.105 9.15 2 9.414 2H13zm-2 2c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1z',
    size: 16,
  },
  '16-link': {
    path:
      'M11.3 6.49a.999.999 0 0 1 1.415 0A4.37 4.37 0 0 1 14 9.604a4.368 4.368 0 0 1-1.285 3.112A4.367 4.367 0 0 1 9.604 14a4.37 4.37 0 0 1-3.113-1.285A1 1 0 0 1 7.905 11.3c.903.902 2.494.902 3.396 0A2.385 2.385 0 0 0 12 9.603c0-.643-.248-1.247-.7-1.698a.999.999 0 0 1 0-1.414zM6.397 2a4.37 4.37 0 0 1 3.113 1.285 1 1 0 0 1-1.414 1.414c-.903-.903-2.493-.903-3.396 0A2.381 2.381 0 0 0 4 6.396c0 .644.248 1.247.699 1.698a.999.999 0 1 1-1.414 1.414A4.368 4.368 0 0 1 2 6.396c0-1.178.456-2.283 1.285-3.111A4.367 4.367 0 0 1 6.396 2zm.095 4.49a.999.999 0 0 1 1.414 0L9.51 8.096a1 1 0 0 1-1.415 1.414L6.491 7.905a.999.999 0 0 1 0-1.414z',
    size: 16,
  },
  '16-link-external': {
    path:
      'M6 1c0 .552.448 1 1 1h1.59L4.465 6.125c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L10 3.41V5c0 .552.448 1 1 1s1-.448 1-1V1c0-.552-.448-1-1-1H7c-.552 0-1 .448-1 1zm4 9H2V2h1c.552 0 1-.448 1-1s-.448-1-1-1H2C.89 0 0 .9 0 2v8c0 1.1.89 2 2 2h8c1.1 0 2-.9 2-2V9c0-.552-.448-1-1-1s-1 .448-1 1v1z',
    size: 16,
  },
  '16-lock': {
    path:
      'M4 6a4 4 0 1 1 8 0v2h1v5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8h1V6zm2 0v2h4V6a2 2 0 1 0-4 0z',
    size: 16,
  },
  '16-minus': {
    path: 'M4 7a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H4z',
    size: 16,
  },
  '16-mobile': {
    path:
      'M5 2H11C11.5523 2 12 2.44772 12 3V13C12 13.5523 11.5523 14 11 14H5C4.44772 14 4 13.5523 4 13V3C4 2.44772 4.44772 2 5 2ZM8 10C7.44772 10 7 10.4477 7 11C7 11.5523 7.44772 12 8 12C8.55228 12 9 11.5523 9 11C9 10.4477 8.55228 10 8 10Z',
    size: 16,
  },
  '16-pin': {
    path:
      'M10 2C10.5523 2 11 2.44772 11 3C11 3.50411 10.627 3.92109 10.1419 3.99001L10.857 9H11C11.5523 9 12 9.44772 12 10C12 10.5523 11.5523 11 11 11H9V13C9 13.5523 8.55228 14 8 14C7.44772 14 7 13.5523 7 13V11H5C4.44772 11 4 10.5523 4 10C4 9.44772 4.44772 9 5 9H5.143L5.85909 3.99015C5.37353 3.92167 5 3.50446 5 3C5 2.44772 5.44772 2 6 2H10Z',
    size: 16,
  },
  '16-pin-crossed': {
    paths: [
      {
        path:
          'M10.5519 6.86233L13.7071 3.70711C14.0976 3.31658 14.0976 2.68342 13.7071 2.29289C13.3166 1.90237 12.6834 1.90237 12.2929 2.29289L2.29289 12.2929C1.90237 12.6834 1.90237 13.3166 2.29289 13.7071C2.68342 14.0976 3.31658 14.0976 3.70711 13.7071L6.41421 11H7V13C7 13.5523 7.44772 14 8 14C8.55228 14 9 13.5523 9 13V11H11C11.5523 11 12 10.5523 12 10C12 9.44772 11.5523 9 11 9H10.857L10.5519 6.86233Z',
      },
      {
        path:
          'M10 2C10.1821 2 10.3528 2.04868 10.4999 2.13374C10.4259 2.17652 10.3562 2.22957 10.2929 2.29289L5.4027 7.18308L5.85909 3.99015C5.37353 3.92167 5 3.50446 5 3C5 2.44772 5.44772 2 6 2H10Z',
      },
    ],
    size: 16,
  },
  '16-plus': {
    path:
      'M13 7H9V3a1 1 0 1 0-2 0v4H3a1 1 0 1 0 0 2h4v4a1 1 0 1 0 2 0V9h4a1 1 0 1 0 0-2',
    size: 16,
  },
  '16-save': {
    path:
      'M2 3C2 2.44772 2.44772 2 3 2H9.66667C9.93188 2 10.1862 2.10536 10.3738 2.29289L13.7071 5.62623C13.8946 5.81376 14 6.06812 14 6.33333V13C14 13.5523 13.5523 14 13 14H3C2.44772 14 2 13.5523 2 13V3ZM4 5C4 4.44772 4.44772 4 5 4H9C9.55228 4 10 4.44772 10 5C10 5.55228 9.55228 6 9 6H5C4.44772 6 4 5.55228 4 5ZM10 10C10 11.1046 9.10457 12 8 12C6.89543 12 6 11.1046 6 10C6 8.89543 6.89543 8 8 8C9.10457 8 10 8.89543 10 10Z',
    size: 16,
  },
  '16-settings': {
    path:
      'M9.235 2c.154 0 .284.108.302.252l.235 1.59c.376.15.721.348 1.042.588l1.536-.6a.314.314 0 0 1 .376.132l1.234 2.076a.297.297 0 0 1-.074.384l-1.302.99c.025.192.044.384.044.588 0 .204-.019.396-.044.588l1.302.99c.117.09.148.252.074.384l-1.234 2.076a.305.305 0 0 1-.376.132l-1.536-.6c-.32.234-.666.438-1.042.588l-.235 1.59a.298.298 0 0 1-.302.252H6.768a.298.298 0 0 1-.303-.252l-.234-1.59a4.539 4.539 0 0 1-1.042-.588l-1.536.6a.314.314 0 0 1-.377-.132L2.043 9.962a.297.297 0 0 1 .074-.384l1.301-.99A4.63 4.63 0 0 1 3.375 8c0-.198.019-.396.043-.588l-1.301-.99a.29.29 0 0 1-.074-.384l1.233-2.076a.305.305 0 0 1 .377-.132l1.536.6c.32-.234.666-.438 1.042-.588l.234-1.59A.298.298 0 0 1 6.768 2zM8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4z',
    size: 16,
  },
  '16-star': {
    path: 'M8 14L9.879 9.879 14 8 9.879 6.12 8 2 6.12 6.12 2 8 6.12 9.879z',
    size: 16,
  },
  '16-switch': {
    path:
      'M13 9C13.5523 9 14 9.44772 14 10C14 10.5128 13.6139 10.9355 13.1166 10.9933L13 11H5.41499L6.7071 12.2929C7.06758 12.6534 7.09531 13.2206 6.79029 13.6129L6.7071 13.7071C6.34661 14.0676 5.77938 14.0953 5.38709 13.7903L5.29288 13.7071L2.29288 10.7071C1.69031 10.1045 2.07232 9.09282 2.88636 9.00598L2.99999 9H13ZM10.6109 2.2097L10.7051 2.29289L13.7051 5.29289C14.3077 5.89547 13.9257 6.90718 13.1116 6.99402L12.998 7H2.99799C2.4457 7 1.99799 6.55228 1.99799 6C1.99799 5.48716 2.38403 5.06449 2.88136 5.00673L2.99799 5H10.583L9.29088 3.70711C8.9304 3.34662 8.90267 2.77939 9.20769 2.3871L9.29088 2.29289C9.65136 1.93241 10.2186 1.90468 10.6109 2.2097Z',
    size: 16,
  },
  '16-sun': {
    path:
      'M9 12V14H7V12H9ZM11.5355 10.1213L12.9497 11.5355L11.5355 12.9497L10.1213 11.5355L11.5355 10.1213ZM4.46447 10.1213L5.87868 11.5355L4.46447 12.9497L3.05025 11.5355L4.46447 10.1213ZM8 5C9.65685 5 11 6.34315 11 8C11 9.65685 9.65685 11 8 11C6.34315 11 5 9.65685 5 8C5 6.34315 6.34315 5 8 5ZM4 7V9H2V7H4ZM14 7V9H12V7H14ZM11.5355 3.05025L12.9497 4.46447L11.5355 5.87868L10.1213 4.46447L11.5355 3.05025ZM4.46447 3.05025L5.87868 4.46447L4.46447 5.87868L3.05025 4.46447L4.46447 3.05025ZM9 2V4H7V2H9Z',
    size: 16,
  },
  '16-title': {
    path:
      'M3 2C2.48223 2 2.05637 2.3935 2.00516 2.89776C2.00175 2.93137 2 2.96548 2 3V5C2 5.55229 2.44772 6 3 6C3.55228 6 4 5.55229 4 5V4L7 4V12H6C5.44772 12 5 12.4477 5 13C5 13.5523 5.44772 14 6 14H8H10C10.5523 14 11 13.5523 11 13C11 12.4477 10.5523 12 10 12H9V4L12 4V5C12 5.55229 12.4477 6 13 6C13.5523 6 14 5.55229 14 5V3C14 2.44772 13.5523 2 13 2H8H3Z',
    size: 16,
  },
  '16-unlink': {
    path:
      'M12.948 7.297A3.966 3.966 0 0114 10a3.971 3.971 0 01-1.172 2.828A3.971 3.971 0 0110 14a3.971 3.971 0 01-2.828-1.172l.125.117 1.417-1.415c.726.602 1.851.601 2.576-.003l.124-.113c.378-.378.586-.88.586-1.414 0-.534-.208-1.036-.586-1.413l.116.125 1.418-1.415zm-1.655-4.004a1 1 0 011.414 1.414l-8 8a.996.996 0 01-1.414 0 1 1 0 010-1.414zM6 2c1.068 0 2.073.416 2.828 1.172l-.125-.118-1.416 1.417c-.726-.603-1.852-.602-2.577.002l-.124.113C4.208 4.964 4 5.466 4 6c0 .475.164.924.466 1.284l.004.003-1.417 1.417a3.96 3.96 0 01-1.047-2.476L2 6c0-1.068.416-2.073 1.172-2.828A3.971 3.971 0 016 2z',
    size: 16,
  },
  '16-unlock': {
    path:
      'M8 2c2.142 0 3.891 1.684 3.995 3.8L12 6v2h1v5c0 .552-.448 1-1 1H4c-.552 0-1-.448-1-1V8h7V6c0-1.105-.895-2-2-2-.586 0-1.122.243-1.496.664-.367.413-.999.45-1.412.084-.413-.367-.45-1-.084-1.412C5.76 2.49 6.84 2 8 2z',
    size: 16,
  },
  '16-user': {
    path:
      'M10 9a4 4 0 0 1 4 4v1H2v-1a4 4 0 0 1 4-4h4zM8 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6z',
    size: 16,
  },
  '16-reset': {
    path:
      'M7.707 6.293l.083.094c.305.392.278.96-.083 1.32-.39.39-1.024.39-1.414 0l-2-2-.083-.094c-.305-.392-.278-.96.083-1.32l2-2 .094-.083c.392-.305.96-.278 1.32.083l.083.094c.305.392.278.96-.083 1.32L7.414 4H8l.217.005C10.877 4.118 13 6.31 13 9c0 2.761-2.239 5-5 5s-5-2.239-5-5c0-.552.448-1 1-1s1 .448 1 1c0 1.657 1.343 3 3 3s3-1.343 3-3-1.343-3-3-3h-.585l.292.293z',
    size: 16,
  },
  '16-reverse': {
    paths: [
      {
        path:
          'M11 1L11 14.9358L14.2901 11.1429C14.6806 10.7524 15.3196 10.7524 15.7101 11.1429C16.1006 11.5334 16.1005 12.1666 15.71 12.5571L11.1339 17.6303C10.3464 18.4178 9 17.8601 9 16.7464L9 1C9 0.447715 9.44772 0 10 0C10.5523 0 11 0.447715 11 1Z',
      },
      {
        path:
          'M5.00293 16.9989V3.06317L1.71286 6.85606C1.32233 7.24658 0.68338 7.24658 0.292856 6.85606C-0.0976685 6.46553 -0.0975937 5.83237 0.292931 5.44184L4.86905 0.368622C5.6565 -0.418831 7.00293 0.13887 7.00293 1.25251V16.9989C7.00293 17.5512 6.55522 17.9989 6.00293 17.9989C5.45065 17.9989 5.00293 17.5512 5.00293 16.9989Z',
      },
    ],
    size: 16,
  },
  '16-warning-solid': {
    path:
      'M2.1 12.116l.045-.098 4.63-9.26a1.37 1.37 0 0 1 2.398-.095l.052.094 4.63 9.261a1.37 1.37 0 0 1-1.122 1.978l-.102.004H3.37a1.37 1.37 0 0 1-1.27-1.884zM7 6a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm0 3v2a1 1 0 1 0 2 0V9a1 1 0 1 0-2 0z',
    size: 16,
  },
  '16-wp-kreator': {
    path:
      'M14 4C14 2.89543 13.1046 2 12 2H4C2.89543 2 2 2.89543 2 4V12C2 13.1046 2.89543 14 4 14H12C13.1046 14 14 13.1046 14 12V4ZM6.30503 7.79579V4H5V12H6.30503V9.51079L7.17531 8.53635L9.45061 12H11L8.0374 7.53704L10.8544 4H9.26343L7.05893 6.81319L6.30503 7.79579Z',
    size: 16,
  },
}

export const icons = { ...defaultIcons, ...smallIcons }

export const tags: { [key: string]: string[] } = {
  '20-alert': ['status', 'warn'],
  '20-alert-solid': ['status', 'warn'],
  '20-arrow-down': [],
  '20-arrow-left': [],
  '20-arrow-right': [],
  '20-arrow-up': [],
  '20-arrowhead-down': ['chevron'],
  '20-arrowhead-left': ['chevron'],
  '20-arrowhead-right': ['chevron'],
  '20-arrowhead-up': ['chevron'],
  '20-article': ['template'],
  '20-article-teaser': ['content part'],
  '20-assistant': ['content part', 'wizzard'],
  '20-bell': ['notifications'],
  '20-bold': ['formatting'],
  '20-calendar': ['date'],
  '20-cart': ['cdc', 'ecommerce', 'content part'],
  '20-close-solid': ['status, fail'],
  '20-code': [],
  '20-chart': ['bar chart', 'graph', 'poll', 'content part'],
  '20-chart-line': ['increase', 'stock', 'market', 'index'],
  '20-chart-candlestick': ['graph', 'chart'],
  '20-check': ['tick'],
  '20-check-solid': ['status', 'done', 'ok', 'success'],
  '20-check-stroke': ['status', 'done', 'ok', 'success'],
  '20-checkbox': ['validation', 'task'],
  '20-close': ['remove', 'erase'],
  '20-comments': ['comment', 'chat'],
  '20-devices': ['comment', 'chat'],
  '20-company': ['organization', 'firm'],
  '20-comparsion-horizontal': [],
  '20-comparsion-vertical': [],
  '20-cursor-drag-and-drop': [],
  '20-delete': ['remove', 'trash', 'bin'],
  '20-desktop': ['screen', 'device', 'breakpoint'],
  '20-document': ['file', 'page'],
  '20-download': ['file'],
  '20-eye': ['preview', 'view'],
  '20-document-add': ['file', 'page'],
  '20-document-edit': [],
  '20-drag-and-drop': [],
  '20-edit': ['pencil', 'pen'],
  '20-excerpt': [],
  '20-facebook': ['fb'],
  '20-gallery': ['photos'],
  '20-google': ['seo'],
  '20-header': ['subheader'],
  '20-image': ['photo', 'photography'],
  '20-image-add': ['photo', 'photography'],
  '20-image-full-width': ['photo', 'photography', 'horizontal'],
  '20-image-wider': ['photo', 'photography'],
  '20-info': ['status', 'information', 'icon', 'icons', 'iconography'],
  '20-info-solid': ['status', 'information'],
  '20-internet': ['earth', 'web', 'www', 'globe'],
  '20-italic': ['formatting'],
  '20-keyboard': ['shortcuts', 'shortcut'],
  '20-link': ['chain', 'connect'],
  '20-link-external': ['new window'],
  '20-list-ordered': ['numerical'],
  '20-list-unordered': ['bullets', 'points'],
  '20-liveblog': ['live', 'chat', 'typing', 'content part'],
  '20-mobile': ['phone', 'device', 'breakpoint', 'contact'],
  '20-more-horizontal': ['menu', 'context', 'dropdown'],
  '20-more-vertical': ['menu', 'context', 'dropdown'],
  '20-play': ['movie', 'video', 'player'],
  '20-plus': ['add'],
  '20-quote': ['quotation marks', 'content part'],
  '20-search': ['browse'],
  '20-settings': ['gear'],
  '20-share': ['social', 'social media', 'content part'],
  '20-smile': ['face', 'emotions', 'emoticons', 'emoji'],
  '20-specification': ['content part', 'rating'],
  '20-square-solid': ['placeholder'],
  '20-square-stroke': ['placeholder'],
  '20-table': ['data', 'list', 'sheet', 'spreadsheet'],
  '20-table-complex': ['data', 'list', 'sheet', 'spreadsheet'],
  '20-tag': ['mark', 'label'],
  '20-tags': ['labels'],
  '20-templates': ['themes'],
  '20-user': ['author'],
  '20-user-add': ['author'],
  '20-user-delete': ['author'],
  '20-user-edit': ['author'],
  '20-users': ['authors', 'readers'],
  '20-users-interactions': ['thumb', 'like'],
  '20-video': ['content part', 'template'],
  '20-view-horizontal': ['image vertical'],
  '20-view-list': [],
  '20-view-mosaic': ['cards'],
  '20-view-vertical': ['image vertical'],
  '20-wallet': ['monetize', 'money'],
  '20-warning': ['status', 'warn'],
  '20-warning-solid': ['status', 'warn'],
  '20-minus': ['dash'],
  '20-lock': [],
  '20-calendar-add-date': [],
  '20-calendar-delete': [],
  '20-calendar-edit': [],
  '20-calendar-range': [],
  '20-reset': [],
  '20-timeline': [],
  '20-video-frame': [],
  '20-fail': ['status', 'stop', 'no'],
  '20-clear-formatting': ['clear', 'formatting', 'styles'],
  '20-copy': ['duplicate'],
  '20-signal': [],
  '20-megaphone': ['shout', 'yell', 'call', 'noise'],
  '20-coffee': ['drink', 'espresso'],
  '20-pako': ['layout'],
  '20-blank': ['layout'],
  '20-time': ['layout', 'clock', 'meter', 'metre'],
  '20-alternatives': [],
  '20-bounding-box': [],
  '20-eye-crossed': [],
  '20-funnel': [],
  '20-home': [],
  '20-maximize': [],
  '20-mention-add': [],
  '20-minimize': [],
  '20-n-2-cr': [],
  '20-object-hide': [],
  '20-object-maximize': [],
  '20-object-mention': [],
  '20-object-show': [],
  '20-pause': [],
  '20-question-solid': [],
  '20-question-stroke': [],
  '20-scale': [],
  '20-sphere': [],
  '20-view-masonry': [],
  '20-zoom-in': [],
  '20-zoom-out': [],
  '20-wp-holding': ['logo', 'holding'],
  '20-wppilot': [],
  '20-chevron-down': ['arrow'],
  '20-chevron-left': ['arrow'],
  '20-chevron-right': ['arrow'],
  '20-chevron-up': ['arrow'],
  '16-alert-solid': ['status', 'warn'],
  '16-arrowhead-right': ['chevron'],
  '16-arrowhead-down': ['chevron'],
  '16-arrowhead-left': ['chevron'],
  '16-arrowhead-up': ['chevron'],
  '16-check': ['tick'],
  '16-close': ['remove', 'erase'],
  '16-edit': ['pencil', 'pen'],
  '16-info-solid': ['status', 'information'],
  '16-link': ['chain', 'connect'],
  '16-lock': [],
  '16-plus': ['add'],
  '16-settings': ['gear'],
  '16-user': ['author'],
  '16-minus': ['dash'],
  '16-warning-solid': ['status', 'warn'],
  '16-link-external': ['new window'],
  '16-delete': ['remove', 'trash', 'bin'],
  '16-copy': ['duplicate'],
  '16-commercial': [
    'ad',
    'advertisement',
    'advertise',
    'merchant',
    'dollar',
    'money',
  ],
  '16-drag-and-drop': [],
  '16-star': [],
  '16-arrow-down': [],
  '16-arrow-left': [],
  '16-arrow-right': [],
  '16-arrow-up': [],
  '16-alternatives': [],
  '16-eye-crossed': [],
  '16-eye': [],
  '16-label': [],
  '16-unlock': ['lock'],
}
